webpackJsonp([2],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENV */
/* unused harmony export server */
/* unused harmony export host */
/* unused harmony export passportHost */
var serverConfigs = __webpack_require__(8);
var ENV = "prod_na";
var server = serverConfigs[ENV];

var host = server.host;
var passportHost = server.passportHost;

/* harmony default export */ __webpack_exports__["a"] = ({
  host: server.host,
  passportHost: server.passportHost,
  env: ENV,
  APP_KEY: 'CZUR_PASSPORT_WEB',
  CHANNEL: 'ALL',
  DEFAULT_PAGE: 'basic.html',
  HTTP_HEADER_KEY: {
    APP_KEY: 'App-Key',
    UDID: 'udid',
    CHANNEL: 'Channel',
    TOKEN: 'T-ID',
    USERID: 'U-ID'
  },
  COOKIE_KEY: {
    U_ID: 'U-ID',
    TOKEN: 'T-ID',
    USER_NAME: 'user',
    LANG: 'lang'
  },
  CALL_BACK: '',
  R_CODE: {
    SUCCESS: 1000,
    INTERNAL_ERROR: 1001,
    INVALID_TOKEN: 1002,
    BAD_ACCESS: 1003,
    PWD_ERROR: 1004,
    USER_INACTIVE: 1005,
    CHANNEL_UNSUPPORT: 1006,
    INVALID_MOBILE: 1007,
    INVALID_EMAIL: 1008,
    SMS_MANY_REQUEST: 1009,
    SMS_SEND_10S: 1010,
    USER_EXIST: 1011,
    MAIL_MANY_REQUEST: 1012,
    MAIL_SEND_10S: 1013,
    INVALID_CODE: 1014,
    IMG_PRO_ERROR: 1015,
    IMG_PRO_ING: 1016,
    INVALID_USER_NAME: 1017,
    USER_NO_EXIST: 1018,
    TIME_OUT: 1019,
    IMG_NOT_FOUND: 1020,
    DEVICE_OCCUPIED: 1021,
    USER_USING_DEVICE: 1022,
    MANY_REQUEST_CODE: 1023,
    PWD_OLD_SAME: 1030,
    PWD_OLD_ERROR: 1031,
    NO_MOBILE_BIND: 1032,
    CODE_ERROR: 1033,
    MOBILE_USED_OTHERS: 1034,
    EMAIL_USED_OTHERS: 1035
  },
  getChannel: function getChannel() {
    var channel = this.getReqParam('Channel');
    if (!channel) {
      channel = this.CHANNEL;
    }
    return channel;
  },
  cookieSet: function cookieSet(key, value) {
    var Days = 30;
    var date = new Date();
    date.setTime(date.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = key + '=' + escape(value) + '; path=/;expires = ' + date.toGMTString();
  },
  cookieGet: function cookieGet(key) {
    var result;
    var mycookie = document.cookie;
    var start2 = mycookie.indexOf(key + '=');
    if (start2 > -1) {
      var start = mycookie.indexOf('=', start2) + 1;
      var end = mycookie.indexOf(';', start);
      if (end === -1) {
        end = mycookie.length;
      }
      result = unescape(mycookie.substring(start, end));
    }
    return result;
  },
  getReqParam: function getReqParam(param) {
    var url = window.location.search;
    var theRequest = {};
    if (url.indexOf('?') !== -1) {
      var str = url.substr(1);
      var strs = str.split('&');
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
      }
    }
    return theRequest[param];
  },
  appendParam: function appendParam(url, param, value) {
    var archor = '';
    if (url.indexOf('#') > 0) {
      var strs = url.split('#');
      url = strs[0];
      archor = strs[1];
    }
    if (url.indexOf('?') >= 0) {
      url = url + '&';
    } else {
      url = url + '?';
    }
    url = url + param + '=' + encodeURIComponent(value);
    if (archor !== '') {
      url = url + '#' + archor;
    }
    return url;
  },
  getLocalStore: function getLocalStore(key) {
    return localStorage.getItem(key);
  },
  setLocalStore: function setLocalStore(key, value) {
    localStorage.setItem(key, value);
  },
  lang: function lang() {
    var requestLang = this.getReqParam('lang');
    var currentLang = this.cookieGet('lang');
    if (requestLang !== undefined && requestLang !== '' && requestLang !== currentLang) {
      currentLang = requestLang;
      this.cookieSet('lang', currentLang);
    }
    if (!currentLang) {
      currentLang = navigator.language;
      if (!currentLang) {
        currentLang = navigator.browserLanguage;
      }
    }
    if (currentLang !== 'en' && currentLang !== 'zh-CN' && currentLang !== 'zh-TW' && currentLang !== 'ru_RU') {
      currentLang = 'en';
    }
    return currentLang;
  },
  local4Service: function local4Service() {
    var lang = this.lang();
    var local = lang.replace('-', '_');
    return local;
  },
  urlRemoveParam: function urlRemoveParam(param) {
    var url = window.location.href;
    if (window.location.search.indexOf(param[0]) >= 0) {
      var hosturl = url.replace(window.location.search, '').replace(window.location.hash, '');
      var params = window.location.search.substr(1);
      var strs = params.split('&');
      for (var m = 0; m < param.length; m++) {
        var one = param[m];
        for (var i = 0; i < strs.length; i++) {
          if (strs[i].indexOf(one) >= 0) {
            strs.splice(i, 1);
            break;
          }
        }
      }
      if (strs.length > 0) {
        var search = strs.join('&');
        hosturl = hosturl + '?' + search;
      }
      url = hosturl + window.location.hash;
    }
    return url;
  }
});

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b72d62d", module.exports)
  }
}

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "countryListWrap",
    staticClass: "country-com-wrap"
  }, [_c('div', {
    staticClass: "country-value",
    on: {
      "click": _vm.selectCountry
    }
  }, [_vm._v("\n    " + _vm._s(_vm.countryName) + "\n    "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList),
      expression: "showList"
    }],
    ref: "countryList",
    staticClass: "country-list-scroll"
  }, [_c('ul', {
    staticClass: "country-list"
  }, _vm._l((_vm.countryList), function(country, index) {
    return _c('li', {
      key: 'country' + index,
      staticClass: "country",
      on: {
        "click": function($event) {
          return _vm.selectCountryAction(country)
        }
      }
    }, [_c('div', {
      staticClass: "country-text"
    }, [_vm._v(_vm._s(_vm.lang === 'zh-CN' ? country.countryName : _vm.lang === 'zh-TW' ? country.countryNameTw : country.countryNameUs))]), _vm._v(" "), (_vm.countryInfo.id === country.id) ? _c('span', {
      staticClass: "icon-selected iconfont"
    }) : _vm._e()])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('span', {
    staticClass: "iconfont icon-down"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-83d2f514", module.exports)
  }
}

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(91);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("8352f614", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2821ade3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./cookie.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2821ade3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./cookie.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(92);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3640e7ea", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-297d6ae3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./mobileCookie.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-297d6ae3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./mobileCookie.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(94);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("345d6592", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4b72d62d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loginCheck.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4b72d62d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loginCheck.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(96);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("792d677d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-83d2f514\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./countryCom.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-83d2f514\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./countryCom.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(167)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/components/personalCenter/resetPwd.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] resetPwd.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-623f25a6", Component.options)
  } else {
    hotAPI.reload("data-v-623f25a6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(37)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(36),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/components/loading/loading.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] loading.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0ae76107", Component.options)
  } else {
    hotAPI.reload("data-v-0ae76107", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(165)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/components/personalCenter/updateSuccess.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] updateSuccess.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b639c1c", Component.options)
  } else {
    hotAPI.reload("data-v-0b639c1c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_loading_loading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_loading_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_nav_nav__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_nav_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_nav_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_loginCheck_loginCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_loginCheck_loginCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_loginCheck_loginCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__countryCom_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__countryCom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__countryCom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_script_validate_js__ = __webpack_require__(9);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'country',
  props: ['lang'],
  data: function data() {
    return {
      processing: false,
      countryInfo: {},
      changePw: false
    };
  },

  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1_components_loading_loading___default.a,
    navbar: __WEBPACK_IMPORTED_MODULE_2_components_nav_nav___default.a,
    LoginCheck: __WEBPACK_IMPORTED_MODULE_3_components_loginCheck_loginCheck___default.a,
    CountryCom: __WEBPACK_IMPORTED_MODULE_4__countryCom_vue___default.a
  },
  methods: {
    setCountry: function setCountry() {
      var _this = this;

      this.processing = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].passportHost + '/account/country/update', {
        'u_id': __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID),
        'countryCode': this.countryInfo.countryCode
      }).then(function (response) {
        _this.processing = false;
        response = response.body;
        if (response.code === 1000) {
          if (_this.changePw) {
            __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].setLocalStore('pw', 1);
            _this.$router.push({ path: '/resetPwd/low' });
            return;
          }

          var callback = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].getReqParam('service');
          if (!__WEBPACK_IMPORTED_MODULE_5_common_script_validate_js__["a" /* default */].stringEmpty(callback)) {
            callback = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].appendParam(callback, 'token', __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.TOKEN));
            callback = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].appendParam(callback, 'u_id', __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID));

            window.location.href = callback;
          } else {
            __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].setLocalStore('request_flag', 1);
            window.location.href = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].DEFAULT_PAGE;
          }
        }
      });
    }
  },
  created: function created() {
    if (this.$route.query.pw === 'true') {
      this.changePw = true;
    }
    __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].setLocalStore('request_flag', 0);
  }
});

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_script_md5_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_loading_loading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_loading_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_loginCheck_loginCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_loginCheck_loginCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_loginCheck_loginCheck__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      id: '',
      username: '',
      password: '',
      requireLogin: false,
      nameValidate: {
        emtpy: false,
        format: false,
        invalidate: false,
        active: false
      },
      reSend: {
        success: false
      },
      pwdValidate: {
        emtpy: false,
        format: false,
        invalidate: false
      },
      loginResult: {
        fail: false,
        msg: '用户名或密码错误'
      },
      processing: true,
      logoutAPIs: []
    };
  },

  created: function created() {
    var _this = this;

    if (__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].getReqParam('action') === 'logout') {
      __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID, '');
      __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.TOKEN, '');
      __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.USER_NAME, '');
      this.$http.get(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].passportHost + '/public/web/logout/list', {}).then(function (response) {
        response = response.body;
        _this.logoutAPIs = response.body;
      });
    }
  },
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_3_components_loading_loading___default.a,
    LoginCheck: __WEBPACK_IMPORTED_MODULE_4_components_loginCheck_loginCheck___default.a
  },
  methods: {
    register: function register() {
      window.location.href = 'register.html';
    },
    findPwd: function findPwd() {
      window.location.href = 'findPwd.html';
    },
    formCheck: function formCheck() {
      this.nameCheck();
      this.pwdCheck();
      return this.nameValidate.invalidate || this.pwdValidate.invalidate;
    },
    nameCheck: function nameCheck() {
      if (__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].stringEmpty(this.username)) {
        this.nameValidate.emtpy = true;
        this.nameValidate.invalidate = true;
        this.nameValidate.format = false;
      } else if (!__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].validateEmail(this.username) && !__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].isTel(this.username)) {
        this.nameValidate.emtpy = false;
        this.nameValidate.invalidate = true;
        this.nameValidate.format = true;
      } else {
        this.nameValidate.emtpy = false;
        this.nameValidate.invalidate = false;
        this.nameValidate.format = false;
      }
    },
    pwdCheck: function pwdCheck() {
      this.loginResult.fail = false;
      if (__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].stringEmpty(this.password)) {
        this.pwdValidate.emtpy = true;
        this.pwdValidate.invalidate = true;
      } else {
        this.pwdValidate.emtpy = false;
        this.pwdValidate.invalidate = false;
      }
    },
    login: function login() {
      var _this2 = this;

      if (!this.formCheck()) {
        this.processing = true;
        this.$http.post(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].passportHost + '/login/', {
          'username': this.username,
          'password': __WEBPACK_IMPORTED_MODULE_2_common_script_md5_js__["a" /* default */].hex_md5(this.password)
        }).then(function (response) {
          _this2.processing = false;
          response = response.body;
          if (response.code === 1005) {
            _this2.nameValidate.active = true;
            _this2.id = response.body;
          } else if (response.code === __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].R_CODE.PWD_ERROR) {
            _this2.nameValidate.active = false;
            _this2.loginResult.fail = true;
            if (_this2.$i18n.locale === 'en') {
              _this2.loginResult.msg = 'wrong user name or password';
            } else if (_this2.$i18n.locale === 'zh_CN') {
              _this2.loginResult.msg = '用户名或密码错误';
            } else if (_this2.$i18n.locale === 'zh_TW') {
              _this2.loginResult.msg = '用戶名或密碼錯誤';
            }
          } else if (response.code === __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].R_CODE.SUCCESS) {
            localStorage.setItem('cookie_necessary', 1);
            localStorage.setItem('cookie_preference', 0);
            localStorage.setItem('cookie_statistics', 0);
            __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID, response.body.id);
            __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.TOKEN, response.body.token);
            __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.USER_NAME, response.body.name);
            _this2.nameValidate.active = false;
            var callback = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].getReqParam('service');
            var passwordType = !__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].passwordRule(_this2.password);
            if (!response.body.countryCode || response.body.countryCode === null || response.body.countryCode === 'null') {
              _this2.$router.push({ path: '/country?pw=' + passwordType });
              return;
            }
            if (!__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].passwordRule(_this2.password)) {
              __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].setLocalStore('pw', 1);
              _this2.$router.push({ path: '/resetPwd/low' });
              return;
            }
            __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].setLocalStore('pw', 0);
            if (!__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].stringEmpty(callback)) {
              callback = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].appendParam(callback, 'token', response.body.token);
              callback = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].appendParam(callback, 'u_id', response.body.id);

              window.location.href = callback;
            } else {
              __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].setLocalStore('request_flag', 1);
              window.location.href = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].DEFAULT_PAGE;
            }
          }
        });
      }
    },
    withOutLogin: function withOutLogin() {
      this.requireLogin = true;
      this.processing = false;
    },
    alreadyLogin: function alreadyLogin() {
      var callback = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].getReqParam('service');
      if (!__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].stringEmpty(callback)) {
        callback = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].appendParam(callback, 'token', __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.TOKEN));
        callback = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].appendParam(callback, 'u_id', __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID));

        window.location.href = callback;
      } else {
        window.location.href = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].DEFAULT_PAGE;
      }
    },
    resend: function resend() {
      var _this3 = this;

      this.processing = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].passportHost + '/public/web/register/resend', {
        'uId': this.id,
        'locale': __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].local4Service()
      }).then(function (response) {
        _this3.processing = false;
        response = response.body;
        if (response.code !== 1000) {
          alert(response.msg);
        } else {
          _this3.reSend.success = true;
          var itemThis = _this3;
          window.setTimeout(function () {
            itemThis.reSend.success = false;
          }, 3000);
        }
      });
    }
  }
});

/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navbar',
  props: ['title', 'back', 'close'],
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    closeAcountAction: function closeAcountAction() {
      this.$router.push('/closeAcount');
    }
  }
});

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_loading_loading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_loading_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_md5_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_nav_nav__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_nav_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_nav_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_loginCheck_loginCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_loginCheck_loginCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_loginCheck_loginCheck__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'resetPwd',
  props: ['lang'],
  data: function data() {
    return {
      low: false,
      oldPwd: '',
      newPwd: '',
      confirmPwd: '',
      oldPwdValidate: {
        emtpy: false,
        invalidate: false,
        error: false,
        format: false
      },
      newPwdValidate: {
        emtpy: false,
        invalidate: false,
        same: false,
        format: false
      },
      confirmPwdValidate: {
        emtpy: false,
        invalidate: false,
        same: false,
        format: false
      },
      loginResult: {
        fail: false
      },
      processing: false
    };
  },

  components: {
    loading: __WEBPACK_IMPORTED_MODULE_2_components_loading_loading___default.a,
    navbar: __WEBPACK_IMPORTED_MODULE_4_components_nav_nav___default.a,
    LoginCheck: __WEBPACK_IMPORTED_MODULE_5_components_loginCheck_loginCheck___default.a
  },
  methods: {
    withOutLogin: function withOutLogin(argument) {
      window.location.href = '/index.html';
    },
    oldPwdCheck: function oldPwdCheck() {
      if (__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].stringEmpty(this.oldPwd)) {
        this.oldPwdValidate.emtpy = true;
        this.oldPwdValidate.format = false;
        this.oldPwdValidate.error = false;
        this.oldPwdValidate.invalidate = true;
      } else if (this.oldPwd.length < 6) {
        this.oldPwdValidate.emtpy = false;
        this.oldPwdValidate.format = false;
        this.oldPwdValidate.error = true;
        this.oldPwdValidate.invalidate = true;
      } else if (!__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].passwordRuleLow(this.oldPwd)) {
        this.oldPwdValidate.emtpy = false;
        this.oldPwdValidate.invalidate = true;
        this.oldPwdValidate.error = false;
        this.oldPwdValidate.format = true;
      } else {
        this.oldPwdValidate.emtpy = false;
        this.oldPwdValidate.invalidate = false;
        this.oldPwdValidate.format = false;
        this.oldPwdValidate.error = false;
      }
    },
    newPwdCheck: function newPwdCheck() {
      if (__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].stringEmpty(this.newPwd)) {
        this.newPwdValidate.emtpy = true;
        this.newPwdValidate.invalidate = true;
      } else if (!__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].passwordRule(this.newPwd)) {
        this.newPwdValidate.emtpy = false;
        this.newPwdValidate.invalidate = true;
        this.newPwdValidate.format = true;
      } else if (this.newPwd === this.oldPwd) {
        this.newPwdValidate.same = true;
        this.newPwdValidate.emtpy = false;
        this.newPwdValidate.invalidate = true;
      } else {
        this.newPwdValidate.emtpy = false;
        this.newPwdValidate.same = false;
        this.newPwdValidate.invalidate = false;
      }
    },
    confirmPwdCheck: function confirmPwdCheck() {
      if (__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].stringEmpty(this.confirmPwd)) {
        this.confirmPwdValidate.emtpy = true;
        this.confirmPwdValidate.invalidate = true;
      } else if (!__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].passwordRule(this.newPwd)) {
        this.confirmPwdValidate.emtpy = false;
        this.confirmPwdValidate.invalidate = true;
        this.confirmPwdValidate.format = true;
      } else if (this.confirmPwd !== this.newPwd) {
        this.confirmPwdValidate.same = true;
        this.confirmPwdValidate.emtpy = false;
        this.confirmPwdValidate.invalidate = true;
      } else {
        this.confirmPwdValidate.emtpy = false;
        this.confirmPwdValidate.invalidate = false;
        this.confirmPwdValidate.same = false;
      }
    },
    formCheck: function formCheck() {
      this.oldPwdCheck();
      this.newPwdCheck();
      this.confirmPwdCheck();
      return this.oldPwdValidate.invalidate || this.newPwdValidate.invalidate || this.confirmPwdValidate.invalidate;
    },
    resetPwd: function resetPwd() {
      var _this = this;

      if (!this.formCheck()) {
        this.processing = true;
        this.$http.post(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].passportHost + '/account/pwd/reset/', {
          'u_id': __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID),
          'o_pwd': __WEBPACK_IMPORTED_MODULE_3_common_script_md5_js__["a" /* default */].hex_md5(this.oldPwd),
          'n_pwd': __WEBPACK_IMPORTED_MODULE_3_common_script_md5_js__["a" /* default */].hex_md5(this.newPwd)
        }).then(function (response) {
          _this.processing = false;
          response = response.body;
          if (response.code !== __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].R_CODE.SUCCESS) {
            if (response.code === 1031) {
              _this.oldPwdValidate.error = true;
            } else if (response.code === __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].USER_NO_EXIST) {
              _this.loginResult.fail = true;
            }
          } else if (response.code === __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].R_CODE.SUCCESS) {
            __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].setLocalStore('pw', 0);
            _this.$router.push({ path: '/updateSuccess' + (_this.low ? '/low' : '') });
          }
        });
      }
    }
  },
  created: function created() {
    this.low = this.$route.params.type === 'low';
    __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].setLocalStore('request_flag', 0);
  }
});

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = {
  findPwd: {
    find: 'Reset your password',
    userName: 'Phone number or email address',
    error_userName_1: 'Please input phone number or email address',
    error_userName_2: 'User not existed',
    get_code: 'Send code',
    get_code_tip: 'Click to send verification code',
    get_code_tip_re: 's resend',
    code: 'Code',
    error_code_1: 'Please input verification code',
    error_code_2: '5 verification codes have been sent. Reach quantity limit of today.',
    error_code_3: 'Incorrect verification code',
    next: 'Continue',
    input_password: 'Password',
    repeat_new_password: 'Confirm password',
    new_password_error: 'Passwords do not match.',
    submit_new_password: 'Change password',
    success_relogin: 'New password set successfully.',
    button_relogin: 'Log in again'
  },
  register: {
    register: 'Join CZUR',
    phone_register: 'Register with phone number',
    email_register: 'Register with e-mail address',
    phone: 'Please input mobile phone number',
    error_phone: 'Invalid phone number',
    already_bound: 'User name exists',
    not_support: 'Channel does not support',
    code: 'Verification code',
    code_error: 'Wrong verification code',
    get_code: 'Send code',
    get_code_tip_re: 's resend',
    error_code_1: 'Verification code fields can\'t be blank',
    error_code_2: '5 verification codes have been sent. Reach quantity limit of today.',
    error_code_3: 'Incorrect verification code',
    error_code_4: 'Verification code sent. Valid for 10 mins. Do not send again within 10 mins.',
    error_code_5: 'Please do not request verification code in such a short period.',
    password_set: '8-20 digits and letters combination',
    password_error_1: 'Password fields can\'t be blank',
    protocol_a: 'I have read and accepted ',
    protocol_b: 'User terms',
    submit: 'Create an account',
    login_now: 'Log in here',
    success: 'Your account is now activated! Please log in and enjoy!',
    login_re: 'Return to log in page',
    email: 'Please input email address',
    email_error: 'Email format is incorrect',
    email_already_bound: 'This e-mail address has been registered.',
    accout_safe_tips: 'Please bind your phone number to this account for protection purpose.',
    password_repeat: 'Repeat 6~20 digit password',
    bind: 'Bind',
    password: 'Set password'
  },
  success: {
    activation: 'E-mail has been sent.',
    activation_email: 'The confirmation email has been sent to your mailbox ',
    click_email: ', click the confirmation link in the email to finish registration.',
    active_email: 'How to proceed if do not receive confirmation e-mail or the link in the e-mail is expired? ',
    email_help1: '● Check if the e-mail is in the junkbox or spam.',
    email_help2: '● Resend confirmation e-mail ',
    activation_success: 'Your CZUR account is now activated! Please log in to use CZUR cloud.',
    jumping_now: 'Go to log in page',
    activation_failed: 'The link is expired.',
    valueText: 'Click to resend',
    jumpingText: 'Jumping（',
    get_code_tip_re: 's resend',
    code_error1: 'You can request verification code for 5 times per day max..',
    code_error2: 'Failed to send'
  },
  index: {
    loginText: 'Log in',
    userName: 'Phone number or email address',
    password: 'Password',
    forgetPwd: 'Forgot password',
    register: 'Create an account',
    userTip: 'Please input mobile phone number or e-mail address',
    pwdTip: 'Please input password',
    loginFail: 'Wrong user name or password',
    errorFormat: 'Incorrect format',
    inactive: 'Please activate the account through the link in the e-mail you received.',
    resend: 'Click to resend',
    success: 'Sent',
    info: 'Account Center'
  },
  basic: {
    editText: 'Edit',
    updateText: 'Update',
    logoutText: 'Log out',
    czurId: 'CZUR ID',
    emailBind: 'Bind with my e-mail',
    phone: 'Phone number for account protection',
    password: 'Password',
    passwordSet: '(Set)',
    bindText: 'Bind',
    unbindText: '(not bind yet)',
    navText: 'Personal Center',
    emailAddress: 'Email address',
    emailEmpty: 'Please input the email address',
    emailInvalid: 'Invalid email address',
    emailBinds: 'This e-mail address has been binded to another account.',
    codeEmpty: 'Please enter verification code',
    codeError: 'Incorrect verification code',
    fiveTimes: 'Max. 5 verification codes can be sent to the same e-mail address each day.',
    hasSent: 'Verification code sent. The code is valid for 10 mins.',
    highFrequency: 'Please do not request verification code in such a short period.',
    emailCode: 'E-mail address verification code',
    emailSend: 'Send code',
    Submit: 'Submit',
    sendAgain: 's resend',
    validateEmail: 'Verify e-mail address',
    emailSent: 'A verification code has been sent to the e-mail address.',
    nextStep: 'Next',
    successText: 'Successfully modified',
    finishText: 'Done',
    updatePwd: 'Change Password',
    oldPwd: 'Current password',
    newPwd: 'New password',
    confirmPwd: 'Confirm new password',
    oldPwdInput: 'Please enter the current password',
    newPwdInput: 'Please enter the new password',
    notSame: 'The new password can\'t be the same as the original password',
    confirmPwdInput: 'Please enter the new password again.',
    notSameWith: 'The passwords entered are not consistent.',
    oldPwdInvalidate: 'The original password is invalid',
    notExist: 'User does not exist',
    fiveTime: 'Max. 5 verification codes can be sent to the same phone number each day.',
    validatePhone: 'Verify phone number',
    phoneSent: 'A SMS verification code has been sent to the phone number.',
    phoneCode: 'SMS verification code',
    phoneInput: 'Please input mobile phone number',
    error_phone: 'Invalid phone number',
    already_bound: 'User name exists',
    bindPhone: 'Bind phone',
    phoneNum: 'Phone number',
    uploadImg: 'Upload image',
    supportText: 'Only supports JPG, png, max. size 200KB',
    confirm: 'Confirm',
    cancel: 'Cancel',
    nicknameLong: 'Enter nickname. Max. 14 characters.',
    closeAcount: 'Close the account',
    nicknameEmpty: 'Nickname required.',
    nicknameEmoji: 'Avoid special characters or emojis.',
    area: 'Area',
    closeHint: 'Warm Reminder',
    closeText: 'CZUR Cloud account is the main account for CZUR APP, StarryMeeting, CZUR Scanner. By closing CZUR Cloud account, all of the accounts for the mentioned apps will be closed as well. Pleaes check again before you decide to proceed.',
    closeWarning: 'All data under this user will be cleared and cannot be restored if this account is closed. Please check again before you decide to proceed.',
    close: 'Close',
    code: 'Verification code',
    slelctCountry: 'Select country/area',
    lowPw: 'Your password is too simple. Please change a more complex combination.',
    logout: 'Log out'
  },
  titleText: {
    account_center: 'Personal Center',
    privacy: 'Privacy Policy - CZUR',
    create_account: 'Create Account - CZUR',
    terms_service: 'Terms of Service - CZUR',
    find_pwd: 'Find Passowrd - CZUR',
    active: 'Activate Account - CZUR',
    account_CZUR: 'Account Center - CZUR'
  }
};

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_nav_nav__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_nav_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_nav_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_loginCheck_loginCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_loginCheck_loginCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_loginCheck_loginCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_script_config_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_validate_js__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'updateSuccess',
  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_0_components_nav_nav___default.a,
    LoginCheck: __WEBPACK_IMPORTED_MODULE_1_components_loginCheck_loginCheck___default.a
  },
  methods: {
    withOutLogin: function withOutLogin(argument) {
      window.location.href = '/index.html';
    },
    backToBasic: function backToBasic() {
      if (this.$route.params.type === 'low') {
        var callback = __WEBPACK_IMPORTED_MODULE_2_common_script_config_js__["a" /* default */].getReqParam('callback');
        if (!__WEBPACK_IMPORTED_MODULE_3_common_script_validate_js__["a" /* default */].stringEmpty(callback)) {
          callback = __WEBPACK_IMPORTED_MODULE_2_common_script_config_js__["a" /* default */].appendParam(callback, 'token', __WEBPACK_IMPORTED_MODULE_2_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_2_common_script_config_js__["a" /* default */].COOKIE_KEY.TOKEN));
          callback = __WEBPACK_IMPORTED_MODULE_2_common_script_config_js__["a" /* default */].appendParam(callback, 'u_id', __WEBPACK_IMPORTED_MODULE_2_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_2_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID));

          window.location.href = callback;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_common_script_config_js__["a" /* default */].setLocalStore('request_flag', 1);
          window.location.href = __WEBPACK_IMPORTED_MODULE_2_common_script_config_js__["a" /* default */].DEFAULT_PAGE;
        }
        return;
      }
      this.$router.push('/baiscPage');
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2_common_script_config_js__["a" /* default */].setLocalStore('request_flag', 0);
  }
});

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = {
  findPwd: {
    find: 'Сбросить пароль',
    userName: 'Телефон или адрес эл.почты',
    error_userName_1: 'Введите номер телефона или адрес эл.почты',
    error_userName_2: 'Пользователь не зарегистрирован',
    get_code: 'Отправить код',
    get_code_tip: 'Нажмите для отправки кода',
    get_code_tip_re: 'сек. ',
    code: 'Код',
    error_code_1: 'Введите проверочный код',
    error_code_2: 'Исчерпан дневной лимит на отправку 5 проверочных кодов',
    error_code_3: 'Ошибка в коде',
    next: 'Продолжить',
    input_password: 'Пароль',
    repeat_new_password: 'Подтвердите пароль',
    new_password_error: 'Пароль подтверждения не совпадает с основным паролем',
    submit_new_password: 'Сменить пароль',
    success_relogin: 'Новый пароль успешно установлен',
    button_relogin: 'Войти снова'
  },
  register: {
    register: 'Регистрация в CZUR',
    phone_register: 'Моб.телефон',
    email_register: 'Эл.почта',
    phone: 'Введите номер моб.телефона',
    error_phone: 'Неверный номер телефона',
    already_bound: 'Пользователь уже зарегистрирован',
    not_support: 'Канал связи не поддерживается',
    code: 'Проверочный код',
    code_error: 'Неверный проверочный код',
    get_code: 'Отправить код',
    get_code_tip_re: 'сек. ',
    error_code_1: 'Поле кода подтверждения не может быть пустым',
    error_code_2: 'Исчерпан дневной лимит на отправку 5 проверочных кодов',
    error_code_3: 'Ошибка в проверочном коде',
    error_code_4: 'Отправленный код подтверждения действует 10 мин., нет необходимости повторной отправки',
    error_code_5: 'Пожалуйста, не запрашивайте проверочный код слишком часто',
    password_set: 'Пароль из 8-20 букв и цифр',
    password_error_1: 'Поле пароля не может быть пустым',
    protocol_a: 'Я прочитал ',
    protocol_b: 'пользовательские условия',
    submit: 'Создать аккаунт',
    login_now: 'Войти здесь',
    success: 'Поздравляем с успешной активацией аккаунта CZUR! Для входа в аккаунт, пожалуйста, авторизуйтесь.',
    login_re: 'Вернуться для повторного входа',
    email: 'Введите адрес эл.почты',
    email_error: 'Неверный формат эл.почты',
    email_already_bound: 'Пользователь уже зарегистрирован',
    accout_safe_tips: 'Пожалуйста, свяжите ваш аккаунт с телефоном для дополнительной безопасности',
    password_repeat: 'Повторите пароль (6-20 символов)',
    bind: 'Связать',
    password: 'Установить пароль'
  },
  success: {
    activation: 'Отправлено',
    activation_email: 'Письмо с подтверждением отправлено на ваш почтовый ящик *, ',
    click_email: 'нажмите на ссылку в письме для завершения регистрации.',
    active_email: 'Что делать, если письмо с подтверждением не получено или ссылка устарела?',
    email_help1: '● Убедитесь, что письмо не попало в Спам и не было удалено.',
    email_help2: '● Отправьте повторно.',
    activation_success: 'Поздравляем с успешной активацией аккаунта CZUR! Для входа в аккаунт, пожалуйста, авторизуйтесь.',
    jumping_now: 'Далее',
    activation_failed: 'Устаревшая ссылка',
    valueText: 'Нажмите для повторной отправки',
    jumpingText: 'Переход (',
    get_code_tip_re: 'сек. ',
    code_error1: 'Всего 5 попыток',
    code_error2: 'Не удалось отправить'
  },
  index: {
    loginText: 'Войти',
    userName: 'Телефон или адрес эл.почты',
    password: 'Пароль',
    forgetPwd: 'Забыли пароль?',
    register: 'Создать аккаунт',
    userTip: 'Введите номер телефона или адрес эл.почты',
    pwdTip: 'Введите пароль',
    loginFail: 'Неверное имя пользователя или пароль',
    errorFormat: 'Неверный формат',
    inactive: 'Письмо для активации отправлено на ваш почтовый ящик',
    resend: 'Нажмите для повторной отправки',
    success: 'Успешно',
    info: 'Аккаунт-центр'
  },
  basic: {
    editText: 'Изменить',
    updateText: 'Обновить',
    logoutText: 'Выйти',
    czurId: 'CZUR ID',
    emailBind: 'Почтовый ящик',
    phone: 'Резервный номер телефона',
    password: 'Пароль',
    passwordSet: '(Отправлено)',
    bindText: 'Связать',
    unbindText: '(Отвязать)',
    navText: 'Персональный центр',
    emailAddress: 'Адрес эл.почты',
    emailEmpty: 'Введите адрес эл.почты',
    emailInvalid: 'Неверный адрес эл.почты',
    emailBinds: 'Указанный адрес эл.почты уже привязан к другому аккаунту',
    codeEmpty: 'Введите код подтверждения',
    codeError: 'Неверный код подтверждения',
    fiveTimes: 'С одного почтового ящика можно отправить не более 5 кодов в день',
    hasSent: 'Код подтверждения выслан, время действия кода - 10 мин.',
    highFrequency: 'Пожалуйста, не запрашивайте проверочный код слишком часто',
    emailCode: 'Отправить код подтверждения по эл.почте',
    emailSend: 'Отправить код',
    Submit: 'Отправить',
    sendAgain: 'сек. ',
    validateEmail: 'Подтвердить адрес эл.почты',
    emailSent: 'Код подтверждения выслан на почтовый ящик ',
    nextStep: 'Далее',
    successText: 'Успешно изменено',
    finishText: 'Завершить',
    updatePwd: 'Сменить пароль',
    oldPwd: 'Текущий пароль',
    newPwd: 'Новый пароль',
    confirmPwd: 'Подтвердить новый пароль',
    oldPwdInput: 'Введите текущий пароль',
    newPwdInput: 'Введите новый пароль',
    notSame: 'Новый пароль не может совпадать с текущим паролем',
    confirmPwdInput: 'Введите пароль подтверждения',
    notSameWith: 'Новый пароль не соответствует паролю подтверждения',
    oldPwdInvalidate: 'Исходный пароль недействителен ',
    notExist: 'Пользователь не зарегистрирован',
    fiveTime: 'С одного номера телефона можно отправить не более 5 кодов в день',
    validatePhone: 'Подтвердить номер телефона',
    phoneSent: 'Код подтверждения отправлен на телефон',
    phoneCode: 'SMS код подтверждения',
    phoneInput: 'Введите номер моб.телефона',
    error_phone: 'Неверный номер телефона',
    already_bound: 'Пользователь уже зарегистрирован',
    bindPhone: 'Привязать телефон',
    phoneNum: 'Номер телефона',
    uploadImg: 'Загрузить изображение',
    supportText: 'Поддерживаются только JPG и PNG форматы, размер файла не более 200 КБ',
    confirm: 'Подтвердить',
    cancel: 'Отменить',
    nicknameLong: 'Пожалуйста, введите никнейм в пределах 14 символов',
    closeAcount: 'Выйти',
    nicknameEmpty: 'имя не может быть пустым',
    nicknameEmoji: 'Использование специальных символов или смайликов не допускается.',
    area: 'область',
    closeHint: 'добрые советы',
    closeText: 'Учетная запись Chengzhe Cloud является общей учетной записью Chengzhe CZUR, Minimalist Scanner, Chengzhe Minimalist Scanner, Starry Meeting и Scanner. Операция отмены приведет к отмене всех вышеуказанных учетных записей, пожалуйста, подтвердите внимательно. ',
    closeWarning: 'После удаления учетной записи все пользовательские данные будут уничтожены, пожалуйста, действуйте с осторожностью! ',
    close: 'выйти',
    code: 'Проверочный код',
    slelctCountry: 'Выберите регион',
    lowPw: 'Ваш пароль слишком простой, вы должны изменить пароль, прежде чем продолжить',
    logout: 'покидать'
  },
  titleText: {
    account_center: 'Центр аккаунтов',
    privacy: 'политика конфиденциальности - CZUR',
    create_account: 'Создать учетную запись - CZUR',
    terms_service: 'условия обслуживания - CZUR',
    find_pwd: 'Найти пароль - CZUR',
    active: 'активный - CZUR',
    account_CZUR: 'Центр аккаунтов - CZUR'
  }
};

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nimg.success-img {\n  width: 0.71rem;\n  height: 0.5rem;\n  margin-top: 1.17rem;\n  margin-bottom: 0.45rem;\n}\n.success-content {\n  text-align: center;\n}\n.success-title {\n  font-size: 0.3rem;\n  color: #272f44;\n  margin-bottom: 0.9rem;\n}\n", ""]);

// exports


/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#login .account-form .form-row {\n  margin-top: 0;\n  margin-bottom: 0;\n  min-height: 0.6rem;\n}\n#login .account-form .form-row .text-error {\n  min-height: 0.16rem;\n  line-height: 0.16rem;\n}\n#login .account-form .form-row.btn-wrap {\n  margin-top: 0.28rem !important;\n}\n.logout-frame {\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  opacity: 0;\n}\n.register-row {\n  font-size: 0.12rem;\n  color: #3d3d3d;\n  text-align: center;\n}\n.register-row ul {\n  display: -ms-flexbox;\n  display: flex;\n}\n.register-row .forget-password {\n  padding-right: 0.15rem;\n  cursor: pointer;\n}\n.register-row .user-register {\n  margin-left: auto;\n  padding-left: 0.15rem;\n  cursor: pointer;\n}\n.resend {\n  color: #272f44;\n  cursor: pointer;\n}\n@media screen and (max-device-width: 720px), (max-width: 720px) {\n#login .account-form .form-row {\n    min-height: 0.8rem;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.text-error {\n  min-height: 0.16rem !important;\n  line-height: 0.16rem !important;\n}\n#login .account-form .form-row.btn-wrap {\n  margin-top: 0rem !important;\n}\n#login .account-form .form-row.btn-wrap .text-error {\n  text-align: center;\n  line-height: 0.44rem !important;\n}\n#login .account-form .form-row.btn-wrap .text-error.lang {\n  line-height: 0.18rem !important;\n  margin-bottom: 0.08rem;\n}\n", ""]);

// exports


/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.account-form {\n  height: 4rem;\n}\n.account-form .form-row.btn-wrap {\n  margin-top: 0.34rem !important;\n}\n", ""]);

// exports


/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.nav {\n  display: none;\n  position: fixed;\n  top: 0px;\n  width: 100%;\n  height: 0.76rem;\n  line-height: 0.76rem;\n  background-color: #090909;\n  text-align: center;\n  font-size: 0.28rem;\n  color: #fff;\n  z-index: 99;\n}\n.nav .nav-wrapper {\n  position: relative;\n}\n.nav .nav-wrapper .back {\n  position: absolute;\n  display: block;\n  height: 0.49rem;\n  width: 0.49rem;\n  top: 0.14rem;\n  left: 0.14rem;\n  color: #fff;\n  line-height: 0.49rem;\n}\n.nav .nav-wrapper .back .iconfont {\n  color: #fafafa !important;\n}\n.nav .nav-wrapper .close {\n  position: absolute;\n  display: block;\n  height: 0.49rem;\n  top: 0.14rem;\n  right: 0.14rem;\n  color: #fff;\n  line-height: 0.49rem;\n  font-size: 0.12rem;\n}\n.nav .nav-wrapper .close .iconfont {\n  color: #fff !important;\n}\n@media screen and (max-device-width: 720px), (max-width: 720px) {\n.nav {\n    display: block;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = {
  findPwd: {
    find: '找回密码',
    userName: '手机号或邮箱',
    error_userName_1: '请输入手机号或邮箱',
    error_userName_2: '用户不存在',
    get_code: '获取验证码',
    get_code_tip: '点击发送验证码',
    get_code_tip_re: '秒后重新发送',
    code: '验证码',
    error_code_1: '请输入验证码',
    error_code_2: '一天内发送验证码次数超过5次，今日无法再发送',
    error_code_3: '验证码错误',
    next: '下一步',
    input_password: '输入新密码',
    repeat_new_password: '重复新密码',
    new_password_error: '两次密码不一致',
    submit_new_password: '提交新密码',
    success_relogin: '密码重置成功，请重新登录',
    button_relogin: '重新登录'
  },
  register: {
    register: '注册',
    phone_register: '手机注册',
    email_register: '邮箱注册',
    phone: '请输入手机号',
    error_phone: '无效手机号',
    already_bound: '用户名已存在',
    not_support: '频道不支持',
    code: '验证码',
    code_error: '验证码错误',
    get_code: '获取验证码',
    get_code_tip_re: '秒后重新发送',
    error_code_1: '验证码不能为空',
    error_code_2: '一天内发送验证码次数超过5次，今日无法再发送',
    error_code_3: '验证码错误',
    error_code_4: '验证码已经被发送，它会在10min内有效',
    error_code_5: '请不要高频请求验证码',
    password_set: '8-20位字母及数字组合密码',
    password_error_1: '密码不能为空',
    protocol_a: '我已阅读并接受',
    protocol_b: '使用协议',
    submit: '提交',
    login_now: '立即登录',
    success: '欢迎您注册成者账号，恭喜您账号激活成功，请重新登陆！',
    login_re: '返回重新登录',
    email: '请输入邮箱',
    email_error: '邮箱格式不正确',
    email_already_bound: '该邮箱已经存在',
    accout_safe_tips: '为了您的账号安全，请绑定手机',
    password_repeat: '8-20位字母及数字组合密码',
    bind: '绑定',
    password: '设置密码'
  },
  success: {
    activation: '邮件已发送',
    activation_email: '您的激活邮件已发送至 ',
    click_email: '，点击邮件内激活按钮完成注册。',
    active_email: '没有收到确认邮件，链接过期， 怎么办？',
    email_help1: '● 看看是否会在回收站，垃圾邮件中？',
    email_help2: '● 重新发送，',
    activation_success: '激活成功',
    jumping_now: '立即跳转',
    activation_failed: '链接过期',
    valueText: '点击重新发送',
    jumpingText: '正在跳转（',
    get_code_tip_re: '秒后重新发送',
    code_error1: '一天只能发送5次验证码',
    code_error2: '发送失败'
  },
  index: {
    loginText: '登录',
    userName: '手机号/邮箱',
    password: '密码',
    forgetPwd: '忘记密码',
    register: '注册新用户',
    userTip: '请输入手机号/邮箱',
    pwdTip: '请输入密码',
    loginFail: '用户名或密码错误',
    errorFormat: '格式不正确',
    inactive: '账号未激活，请到邮箱激活',
    resend: '点此重发一封',
    success: '发送成功',
    info: '账号中心',
    protocol: '使用协议'
  },
  basic: {
    editText: '编辑',
    updateText: '修改',
    logoutText: '退出登录',
    czurId: '成者ID',
    emailBind: '绑定邮箱',
    phone: '安全手机',
    password: '密码',
    passwordSet: '(已设置)',
    bindText: '绑定',
    unbindText: '(未绑定)',
    navText: '个人中心',
    emailAddress: '邮箱地址',
    emailEmpty: '请输入邮箱地址',
    emailInvalid: '无效的邮箱地址',
    emailBinds: '该邮箱已绑定其他账号',
    codeEmpty: '请输入验证码',
    codeError: '验证码错误',
    fiveTimes: '同一个邮箱，一天只能发送5次验证码',
    hasSent: '验证码已经被发送，它会在10min内有效',
    highFrequency: '请不要高频请求验证码',
    emailCode: '邮箱验证码',
    emailSend: '发送验证码',
    Submit: '提交',
    sendAgain: '秒后重新发送',
    validateEmail: '验证邮箱',
    emailSent: '已发送验证码到邮箱',
    nextStep: '下一步',
    successText: '修改成功',
    finishText: '完成',
    updatePwd: '修改密码',
    oldPwd: '当前密码',
    newPwd: '新密码',
    confirmPwd: '确认新密码',
    oldPwdInput: '请输入当前密码',
    newPwdInput: '请输入新密码',
    notSame: '新密码不能与原密码相同',
    confirmPwdInput: '请输入确认密码',
    notSameWith: '新密码与确认密码不一致',
    oldPwdInvalidate: '原密码无效',
    notExist: '用户不存在',
    fiveTime: '同一个手机号，一天只能发送5次验证码',
    validatePhone: '验证手机号',
    phoneSent: '已发送验证码到手机',
    phoneCode: '短信验证码',
    phoneInput: '请输入手机号',
    error_phone: '无效手机号',
    already_bound: '该手机号已经绑定其他账号',
    bindPhone: '绑定手机',
    phoneNum: '手机号码',
    uploadImg: '上传图片',
    supportText: '只支持JPG, png, 大小不超过200KB',
    confirm: '确定',
    cancel: '取消',
    nicknameLong: '请输入14字符以内昵称',
    area: '地区',
    closeAcount: '注销账号',
    closeHint: '温馨提示',
    closeText: '成者云账号为成者 CZUR、极简扫描、成者极简扫描、Starry Meeting、Scanner通用账号,注销操作将会注销以上所有账号，请仔细确认。',
    closeWarning: '*账号一经注销，将销毁所有用户数据，请谨慎操作！',
    close: '注销',
    code: '验证码',
    slelctCountry: '选择地区',
    lowPw: '你的密码过于简单，必须修改密码后才能继续',
    logout: '退出',
    nicknameEmpty: '名字不能为空',
    nicknameEmoji: '禁止输入特殊符号或表情'
  },
  titleText: {
    account_center: '个人信息',
    privacy: '成者科技 - 隐私政策',
    create_account: '成者科技 - 注册中心',
    terms_service: '成者科技 - 使用协议',
    find_pwd: '成者科技 - 找回密码',
    active: '成者科技 - 激活',
    account_CZUR: '成者科技 - 账户中心'
  }
};

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = {
  findPwd: {
    find: '找回密碼',
    userName: '手機號或郵箱',
    error_userName_1: '請輸入手機號或郵箱',
    error_userName_2: '用戶不存在',
    get_code: '獲取驗證碼',
    get_code_tip: '點擊獲取驗證碼',
    get_code_tip_re: '秒後重新發送',
    code: '驗證碼',
    error_code_1: '請輸入驗證碼',
    error_code_2: '一天內發送驗證碼次數超過5次，今日無法再發送',
    error_code_3: '驗證碼錯誤',
    next: '下一步',
    input_password: '輸入新密碼',
    repeat_new_password: '重複新密碼',
    new_password_error: '兩次密碼不一致',
    submit_new_password: '提交新密碼',
    success_relogin: '密碼重置成功，請重新登錄',
    button_relogin: '重新登錄'
  },
  register: {
    register: '註冊',
    phone_register: '手機號註冊',
    email_register: '郵箱註冊',
    phone: '請輸入手機號碼',
    error_phone: '無效的手機號碼',
    already_bound: '用戶名已存在',
    not_support: '頻道不支持',
    code: '驗證碼',
    code_error: '驗證碼錯誤',
    get_code: '獲取驗證碼',
    get_code_tip_re: '秒後重新發送',
    error_code_1: '驗證碼不能為空',
    error_code_2: '一天內發送驗證碼次數超過5次，今日無法再發送',
    error_code_3: '驗證碼錯誤',
    error_code_4: '驗證碼已發送，10分鐘內有效，請勿重新發送',
    error_code_5: '請不要高頻請求驗證碼',
    password_set: '8-20位字母及數字組合密碼',
    password_error_1: '密碼不能為空',
    protocol_a: '我已閱讀並接受',
    protocol_b: '使用協議',
    submit: '提交',
    login_now: '立即登錄',
    success: '歡迎您註冊成者賬號，恭喜您賬號激活成功，請重新登陸！',
    login_re: '返回重新登錄',
    email: '請輸入郵箱',
    email_error: '郵箱格式不正確',
    email_already_bound: '該郵箱已經存在',
    accout_safe_tips: '為了您的賬號安全，請綁定手機',
    password_repeat: '重複6~20位密碼',
    bind: '綁定',
    password: '設置密碼'
  },
  success: {
    activation: '郵件已發送',
    activation_email: '您的激活郵件已發送至 ',
    click_email: '，點擊郵件內激活按鈕完成註冊。',
    active_email: '沒有收到確認郵件，鏈接過期， 怎麼辦？',
    email_help1: '● 看看是否會在回收站，垃圾郵件中？',
    email_help2: '● 重新發送，',
    activation_success: '激活成功',
    jumping_now: '立即跳轉',
    activation_failed: '鏈接過期',
    valueText: '點擊重新發送',
    jumpingText: '正在跳轉（',
    get_code_tip_re: '秒後重新發送',
    code_error1: '一天只能發送5次驗證碼',
    code_error2: '發送失敗'
  },
  index: {
    loginText: '登錄',
    userName: '手機號/郵箱',
    password: '密碼',
    forgetPwd: '忘記密碼',
    register: '註冊新用護',
    userTip: '請輸入手機號/郵箱',
    pwdTip: '請輸入密碼',
    loginFail: '用戶名或密碼錯誤',
    errorFormat: '格式不正確',
    inactive: '賬號未激活，請到郵箱激活',
    resend: '點此重發一封',
    success: '發送成功',
    info: '賬戶中心'
  },
  basic: {
    editText: '編輯',
    updateText: '修改',
    logoutText: '退出登錄',
    czurId: '成者ID',
    emailBind: '綁定郵箱',
    phone: '安全手機',
    password: '密碼',
    passwordSet: '(已設置)',
    bindText: '綁定',
    unbindText: '(未綁定)',
    navText: '個人中心',
    emailAddress: '郵箱地址',
    emailEmpty: '請輸入郵箱地址',
    emailInvalid: '無效的郵箱地址',
    emailBinds: '該郵箱已綁定其他賬號',
    codeEmpty: '請輸入驗證碼',
    codeError: '驗證碼錯誤',
    fiveTimes: '同一個郵箱，一天只能發送5次驗證碼',
    hasSent: '驗證碼已經被發送，它會在10min內有效',
    highFrequency: '請不要高頻請求驗證碼',
    emailCode: '郵箱驗證碼',
    emailSend: '发送验证码',
    Submit: '提交',
    sendAgain: '秒後重新發送',
    validateEmail: '驗證郵箱',
    emailSent: '已發送驗證碼到郵箱',
    nextStep: '下一步',
    successText: '修改成功',
    finishText: '完成',
    updatePwd: '修改密碼',
    oldPwd: '當前密碼',
    newPwd: '新密碼',
    confirmPwd: '確認新密碼',
    oldPwdInput: '請輸入當前密碼',
    newPwdInput: '請輸入新密碼',
    notSame: '新密碼不能與原密碼相同',
    confirmPwdInput: '請輸入確認密碼',
    notSameWith: '新密碼與確認密碼不一致',
    oldPwdInvalidate: '原密碼無效',
    notExist: '用戶不存在',
    fiveTime: '同一個手機號，一天只能發送5次驗證碼',
    validatePhone: '驗證手機號',
    phoneSent: '已發送驗證碼到手機',
    phoneCode: '短信驗證碼',
    phoneInput: '請輸入手機號碼',
    error_phone: '無效的手機號碼',
    already_bound: '該手機號已經綁定其他賬號',
    bindPhone: '綁定手機',
    phoneNum: '手機號碼',
    uploadImg: '上傳圖片',
    supportText: '只支持JPG, png, 大小不超過200KB',
    confirm: '確定',
    cancel: '取消',
    nicknameLong: '請輸入14字元以內昵稱',
    closeAcount: '註銷賬號',
    nicknameEmpty: '名字不能為空',
    nicknameEmoji: '禁止輸入特殊符號或表情',
    area: '地區',
    closeHint: '溫馨提示',
    closeText: '成者雲帳號為成者CZUR、極簡掃描、成者極簡掃描、Starry Meeting、Scanner通用帳號，註銷操作將會註銷以上所有帳號，請仔細確認。',
    closeWarning: '帳號一經註銷，將銷毀所有用戶數據，請謹慎操作！',
    close: '註銷',
    code: '驗證碼',
    slelctCountry: '選擇地區',
    lowPw: '你的密碼過於簡單，必須修改密碼後才能繼續',
    logout: '退出'

  },
  titleText: {
    account_center: '個人信息',
    privacy: '成者科技 - 隱私政策',
    create_account: '成者科技 - 註冊中心',
    terms_service: '成者科技 - 使用協議',
    find_pwd: '成者科技 - 找回密碼',
    active: '成者科技-激活',
    account_CZUR: '成者科技-賬號中心'
  }

};

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-content"
  }, [_c('navbar', {
    attrs: {
      "title": _vm.$t('basic.navText')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "account-wrapper"
  }, [_c('div', {
    staticClass: "account-form success-content"
  }, [_c('img', {
    staticClass: "success-img",
    attrs: {
      "src": __webpack_require__(39)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "success-title"
  }, [_vm._v(_vm._s(_vm.$t("basic.successText")))]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('button', {
    staticClass: "czur-style",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backToBasic
    }
  }, [_vm._v(_vm._s(_vm.$t("basic.finishText")))])])])]), _vm._v(" "), _c('LoginCheck', {
    on: {
      "nologin": _vm.withOutLogin
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0b639c1c", module.exports)
  }
}

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-content",
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "account-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requireLogin),
      expression: "requireLogin"
    }],
    staticClass: "slogan-wrapper"
  }, [_c('span', {
    staticClass: "slogan-text"
  }, [_vm._v(_vm._s(_vm.$t("index.loginText")))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requireLogin),
      expression: "requireLogin"
    }],
    staticClass: "account-form"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-input",
    class: {
      'input-require': _vm.nameValidate.invalidate
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('index.userName')
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.nameValidate.emtpy) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t("index. userTip")))]) : _vm._e(), _vm._v(" "), (_vm.nameValidate.format) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t("index. errorFormat")))]) : _vm._e(), _vm._v(" "), (_vm.nameValidate.active) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t("index. inactive")) + " "), _c('span', {
    staticClass: "resend",
    on: {
      "click": _vm.resend
    }
  }, [_vm._v(_vm._s(_vm.$t("index. resend")))]), _vm._v(" "), (_vm.reSend.success) ? _c('span', [_vm._v(_vm._s(_vm.$t("index. success")))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-input",
    class: {
      'input-require': _vm.pwdValidate.invalidate
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('index.password')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.pwdValidate.emtpy) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t("index. pwdTip")))]) : _vm._e(), _vm._v(" "), (_vm.loginResult.fail) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t("index. loginFail")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-row btn-wrap"
  }, [_c('button', {
    staticClass: "czur-style",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t("index.loginText")))])]), _vm._v(" "), _c('div', {
    staticClass: "register-row"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "forget-password",
    on: {
      "click": _vm.findPwd
    }
  }, [_vm._v(_vm._s(_vm.$t("index.forgetPwd")))]), _vm._v(" "), _c('li', {
    staticClass: "user-register",
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.$t("index.register")))])])])]), _vm._v(" "), _c('loading', {
    attrs: {
      "appear": _vm.processing
    }
  }), _vm._v(" "), _c('LoginCheck', {
    on: {
      "nologin": _vm.withOutLogin,
      "islogin": _vm.alreadyLogin
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logout-frame"
  }, _vm._l((_vm.logoutAPIs), function(api) {
    return _c('iframe', {
      attrs: {
        "src": api,
        "frameborder": "0"
      }
    })
  }), 0)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-550244e1", module.exports)
  }
}

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-content"
  }, [_c('navbar', {
    attrs: {
      "title": _vm.$t('basic.navText'),
      "back": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "account-wrapper"
  }, [_c('div', {
    staticClass: "slogan-wrapper"
  }, [_c('span', {
    staticClass: "slogan-text"
  }, [_vm._v(_vm._s(_vm.$t('basic.updatePwd')))])]), _vm._v(" "), _c('div', {
    staticClass: "account-form"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPwd),
      expression: "oldPwd"
    }],
    staticClass: "form-input",
    class: {
      'input-require': _vm.oldPwdValidate.invalidate
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('basic.oldPwd')
    },
    domProps: {
      "value": (_vm.oldPwd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPwd($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPwd = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.oldPwdValidate.emtpy) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.oldPwdInput')))]) : _vm._e(), _vm._v(" "), (_vm.oldPwdValidate.error) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.oldPwdInvalidate')))]) : _vm._e(), _vm._v(" "), (_vm.loginResult.fail) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.notExist')))]) : _vm._e(), _vm._v(" "), (_vm.oldPwdValidate.format) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('register.password_set')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPwd),
      expression: "newPwd"
    }],
    staticClass: "form-input",
    class: {
      'input-require': _vm.newPwdValidate.invalidate
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('basic.newPwd')
    },
    domProps: {
      "value": (_vm.newPwd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPwd($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPwd = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.newPwdValidate.emtpy) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.newPwdInput')))]) : _vm._e(), _vm._v(" "), (_vm.newPwdValidate.same) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.notSame')))]) : _vm._e(), _vm._v(" "), (_vm.newPwdValidate.format) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('register.password_set')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPwd),
      expression: "confirmPwd"
    }],
    staticClass: "form-input",
    class: {
      'input-require': _vm.confirmPwdValidate.invalidate
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('basic.confirmPwd')
    },
    domProps: {
      "value": (_vm.confirmPwd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPwd($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPwd = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.confirmPwdValidate.emtpy) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.confirmPwdInput')))]) : _vm._e(), _vm._v(" "), (_vm.confirmPwdValidate.same) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.notSameWith')))]) : _vm._e(), _vm._v(" "), (_vm.confirmPwdValidate.format) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('register.password_set')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-row btn-wrap"
  }, [_c('p', {
    staticClass: "text-error",
    class: {
      lang: _vm.lang === 'en' || _vm.lang === 'ru_RU'
    }
  }, [_vm._v(_vm._s(_vm.low ? _vm.$t('basic.lowPw') : ''))]), _vm._v(" "), _c('button', {
    staticClass: "czur-style",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPwd
    }
  }, [_vm._v(_vm._s(_vm.$t('basic.Submit')))])])]), _vm._v(" "), _c('loading', {
    attrs: {
      "appear": _vm.processing
    }
  })], 1), _vm._v(" "), _c('LoginCheck', {
    on: {
      "nologin": _vm.withOutLogin
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-623f25a6", module.exports)
  }
}

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-content validate-wraper"
  }, [_c('navbar', {
    attrs: {
      "title": _vm.$t('basic.navText'),
      "back": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "account-wrapper"
  }, [_c('div', {
    staticClass: "slogan-wrapper"
  }, [_c('span', {
    staticClass: "slogan-text"
  }, [_vm._v(_vm._s(_vm.$t("basic.slelctCountry")))])]), _vm._v(" "), _c('div', {
    staticClass: "account-form"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('country-com', {
    attrs: {
      "lang": _vm.lang
    },
    model: {
      value: (_vm.countryInfo),
      callback: function($$v) {
        _vm.countryInfo = $$v
      },
      expression: "countryInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-row btn-wrap"
  }, [_c('button', {
    staticClass: "czur-style",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setCountry
    }
  }, [_vm._v(_vm._s(_vm.$t("basic.Submit")))])])]), _vm._v(" "), _c('loading', {
    attrs: {
      "appear": _vm.processing
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68664c8a", module.exports)
  }
}

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-wrapper"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.back),
      expression: "back"
    }],
    staticClass: "back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "icon-back iconfont"
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.close) ? _c('span', {
    staticClass: "btn-img close",
    on: {
      "click": _vm.closeAcountAction
    }
  }, [_c('span', {
    staticClass: "iconfont icon-zhuxiao"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('basic.close')))])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eac0da56", module.exports)
  }
}

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(145);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("dca656aa", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0b639c1c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./updateSuccess.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0b639c1c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./updateSuccess.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(146);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1854198e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-550244e1\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./login.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-550244e1\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./login.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(147);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e4785d46", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-623f25a6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resetPwd.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-623f25a6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resetPwd.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(148);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0d7845c0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-68664c8a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./country.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-68664c8a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./country.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(149);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e63ebf74", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-eac0da56\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./nav.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-eac0da56\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./nav.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(106)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(100),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/components/loginCheck/loginCheck.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] loginCheck.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b72d62d", Component.options)
  } else {
    hotAPI.reload("data-v-4b72d62d", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(472)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(440),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/index/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b45d8a6e", Component.options)
  } else {
    hotAPI.reload("data-v-b45d8a6e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'czurfooter',
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  },
  methods: {
    changeLocale: function changeLocale(locale) {
      var requestLang = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].getReqParam('lang');
      __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet('lang', locale);
      if (requestLang !== undefined && requestLang !== '' && locale !== requestLang) {
        window.location.href = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].urlRemoveParam('lang');
      }
      this.$emit('changeAppLocale', locale);
    }
  }
});

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.footer-wrapper {\n  padding: 4px 0 2px;\n  font-size: 12px;\n  color: #757575;\n  text-align: center;\n  background: #f4f4f4;\n}\n.footer-wrapper .lang-wrapper {\n  padding: 8px 0;\n}\n.footer-wrapper .lang-wrapper ul {\n  display: block;\n  margin: 0 auto;\n  width: 324px;\n}\n.footer-wrapper .lang-wrapper ul>li {\n  display: block;\n  list-style: none;\n  float: left;\n  width: 80px;\n  text-align: center;\n  border-right: 1px solid #7f7f7f;\n}\n.footer-wrapper .lang-wrapper ul>li:last-child {\n  border: none;\n}\n", ""]);

// exports


/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lang_en__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_lang_zh_CN__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_lang_zh_TW__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_lang_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_lang_zh_TW__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_lang_ru__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_lang_ru___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_lang_ru__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_login_login_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_login_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_login_login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_country_country_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_country_country_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_country_country_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_personalCenter_resetPwd_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_personalCenter_resetPwd_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_personalCenter_resetPwd_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_personalCenter_updateSuccess_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_personalCenter_updateSuccess_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_personalCenter_updateSuccess_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_common_script_config_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_common_script_getRem_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_common_script_getRem_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_common_script_getRem_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_common_stylus_index_styl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_common_stylus_index_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_index_css__);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_13_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.APP_KEY] = __WEBPACK_IMPORTED_MODULE_13_common_script_config_js__["a" /* default */].APP_KEY;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_13_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.CHANNEL] = __WEBPACK_IMPORTED_MODULE_13_common_script_config_js__["a" /* default */].getChannel();
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_13_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.USERID] = __WEBPACK_IMPORTED_MODULE_13_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_13_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_13_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.TOKEN] = __WEBPACK_IMPORTED_MODULE_13_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_13_common_script_config_js__["a" /* default */].COOKIE_KEY.TOKEN);
  next(function (response) {
    return response;
  });
});

var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: 'en',
  messages: {
    'en': __WEBPACK_IMPORTED_MODULE_3__common_lang_en___default.a,
    'zh-CN': __WEBPACK_IMPORTED_MODULE_4__common_lang_zh_CN___default.a,
    'zh-TW': __WEBPACK_IMPORTED_MODULE_5__common_lang_zh_TW___default.a,
    'ru_RU': __WEBPACK_IMPORTED_MODULE_6__common_lang_ru___default.a
  }
});

var currentLang = __WEBPACK_IMPORTED_MODULE_13_common_script_config_js__["a" /* default */].lang();

setI18nLanguage(currentLang);

function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('title', {
  inserted: function inserted(el, binding) {
    document.title = el.dataset.title;
  },
  update: function update(el, binding) {
    document.title = el.dataset.title;
  }
});

var routes = [{ path: '/', redirect: '/login' }, { path: '/login', component: __WEBPACK_IMPORTED_MODULE_8_components_login_login_vue___default.a }, { path: '/country', component: __WEBPACK_IMPORTED_MODULE_9_components_country_country_vue___default.a }, { path: '/resetPwd/:type', component: __WEBPACK_IMPORTED_MODULE_10_components_personalCenter_resetPwd_vue___default.a }, { path: '/updateSuccess/:type', component: __WEBPACK_IMPORTED_MODULE_11_components_personalCenter_updateSuccess_vue___default.a }];

var router = new __WEBPACK_IMPORTED_MODULE_7_vue_router__["a" /* default */]({
  routes: routes
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: router,
  i18n: i18n,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_12__index_vue___default.a }
});

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(29)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(28),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/components/footer/footer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] footer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0de41ea6", Component.options)
  } else {
    hotAPI.reload("data-v-0de41ea6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(169)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/components/nav/nav.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] nav.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-eac0da56", Component.options)
  } else {
    hotAPI.reload("data-v-eac0da56", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-footer footer-wrapper"
  }, [_c('div', {
    staticClass: "lang-wrapper"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('zh-CN')
      }
    }
  }, [_vm._v("简体")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('zh-TW')
      }
    }
  }, [_vm._v("繁體")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('en')
      }
    }
  }, [_vm._v("English")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('ru_RU')
      }
    }
  }, [_vm._v("Pусский")])])])]), _vm._v(" "), _c('div', {
    staticClass: "copy-right"
  }, [_c('span', [_vm._v("Copyright © " + _vm._s(_vm.year) + " CZUR Technology Co.,Ltd. All rights reserved. "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("辽ICP备13011158号-8")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0de41ea6", module.exports)
  }
}

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(25);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("57512e35", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0de41ea6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./footer.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0de41ea6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./footer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cookie_cookie_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cookie_cookie_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__cookie_cookie_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mobileCookie_mobileCookie_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mobileCookie_mobileCookie_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mobileCookie_mobileCookie_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_login_login__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_login_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_login_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_footer_footer__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_footer_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_footer_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_script_config_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_header_header__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_header_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_header_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_country_country_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_country_country_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_country_country_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'index',
  data: function data() {
    return {
      lang: '',
      showCountry: false,
      isPhone: false,
      showCookie: false
    };
  },

  components: {
    login: __WEBPACK_IMPORTED_MODULE_2_components_login_login___default.a,
    czurfooter: __WEBPACK_IMPORTED_MODULE_3_components_footer_footer___default.a,
    basicheader: __WEBPACK_IMPORTED_MODULE_5_components_header_header___default.a,
    Country: __WEBPACK_IMPORTED_MODULE_6_components_country_country_vue___default.a,
    cookie: __WEBPACK_IMPORTED_MODULE_0__cookie_cookie_vue___default.a,
    mobileCookie: __WEBPACK_IMPORTED_MODULE_1__mobileCookie_mobileCookie_vue___default.a
  },
  created: function created() {
    if (window.screen.availWidth < 1000) {
      this.isPhone = true;
    }
    this.showCookie = __WEBPACK_IMPORTED_MODULE_4_common_script_config_js__["a" /* default */].env === 'prod_na' || __WEBPACK_IMPORTED_MODULE_4_common_script_config_js__["a" /* default */].env === 'test_na';
  },

  methods: {
    changeLanguage: function changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.lang = lang;
      __WEBPACK_IMPORTED_MODULE_4_common_script_config_js__["a" /* default */].cookieSet('lang', lang);
    },
    changeAppLocale: function changeAppLocale(locale) {
      this.changeLanguage(locale);
    },
    showCountryAction: function showCountryAction() {
      this.showCountry = true;
    }
  },
  mounted: function mounted() {
    this.changeLanguage(this.$i18n.locale);
  }
});

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  hex_md5: hex_md5
});

var hexcase = 0;
var b64pad = "";
function hex_md5(s) {
  return rstr2hex(rstr_md5(str2rstr_utf8(s))).toUpperCase();
}
function b64_md5(s) {
  return rstr2b64(rstr_md5(str2rstr_utf8(s)));
}
function any_md5(s, e) {
  return rstr2any(rstr_md5(str2rstr_utf8(s)), e);
}
function hex_hmac_md5(k, d) {
  return rstr2hex(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
}
function b64_hmac_md5(k, d) {
  return rstr2b64(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
}
function any_hmac_md5(k, d, e) {
  return rstr2any(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)), e);
}

function md5_vm_test() {
  return hex_md5("abc").toLowerCase() == "900150983cd24fb0d6963f7d28e17f72";
}

function rstr_md5(s) {
  return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
}

function rstr_hmac_md5(key, data) {
  var bkey = rstr2binl(key);
  if (bkey.length > 16) bkey = binl_md5(bkey, key.length * 8);

  var ipad = Array(16),
      opad = Array(16);
  for (var i = 0; i < 16; i++) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5C5C5C5C;
  }

  var hash = binl_md5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binl_md5(opad.concat(hash), 512 + 128));
}

function rstr2hex(input) {
  try {
    hexcase;
  } catch (e) {
    hexcase = 0;
  }
  var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  var output = "";
  var x;
  for (var i = 0; i < input.length; i++) {
    x = input.charCodeAt(i);
    output += hex_tab.charAt(x >>> 4 & 0x0F) + hex_tab.charAt(x & 0x0F);
  }
  return output;
}

function rstr2b64(input) {
  try {
    b64pad;
  } catch (e) {
    b64pad = '';
  }
  var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var output = "";
  var len = input.length;
  for (var i = 0; i < len; i += 3) {
    var triplet = input.charCodeAt(i) << 16 | (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) | (i + 2 < len ? input.charCodeAt(i + 2) : 0);
    for (var j = 0; j < 4; j++) {
      if (i * 8 + j * 6 > input.length * 8) output += b64pad;else output += tab.charAt(triplet >>> 6 * (3 - j) & 0x3F);
    }
  }
  return output;
}

function rstr2any(input, encoding) {
  var divisor = encoding.length;
  var i, j, q, x, quotient;

  var dividend = Array(Math.ceil(input.length / 2));
  for (i = 0; i < dividend.length; i++) {
    dividend[i] = input.charCodeAt(i * 2) << 8 | input.charCodeAt(i * 2 + 1);
  }

  var full_length = Math.ceil(input.length * 8 / (Math.log(encoding.length) / Math.log(2)));
  var remainders = Array(full_length);
  for (j = 0; j < full_length; j++) {
    quotient = Array();
    x = 0;
    for (i = 0; i < dividend.length; i++) {
      x = (x << 16) + dividend[i];
      q = Math.floor(x / divisor);
      x -= q * divisor;
      if (quotient.length > 0 || q > 0) quotient[quotient.length] = q;
    }
    remainders[j] = x;
    dividend = quotient;
  }

  var output = "";
  for (i = remainders.length - 1; i >= 0; i--) {
    output += encoding.charAt(remainders[i]);
  }return output;
}

function str2rstr_utf8(input) {
  var output = "";
  var i = -1;
  var x, y;

  while (++i < input.length) {
    x = input.charCodeAt(i);
    y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
    if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
      x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
      i++;
    }

    if (x <= 0x7F) output += String.fromCharCode(x);else if (x <= 0x7FF) output += String.fromCharCode(0xC0 | x >>> 6 & 0x1F, 0x80 | x & 0x3F);else if (x <= 0xFFFF) output += String.fromCharCode(0xE0 | x >>> 12 & 0x0F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);else if (x <= 0x1FFFFF) output += String.fromCharCode(0xF0 | x >>> 18 & 0x07, 0x80 | x >>> 12 & 0x3F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
  }
  return output;
}

function str2rstr_utf16le(input) {
  var output = "";
  for (var i = 0; i < input.length; i++) {
    output += String.fromCharCode(input.charCodeAt(i) & 0xFF, input.charCodeAt(i) >>> 8 & 0xFF);
  }return output;
}

function str2rstr_utf16be(input) {
  var output = "";
  for (var i = 0; i < input.length; i++) {
    output += String.fromCharCode(input.charCodeAt(i) >>> 8 & 0xFF, input.charCodeAt(i) & 0xFF);
  }return output;
}

function rstr2binl(input) {
  var output = Array(input.length >> 2);
  for (var i = 0; i < output.length; i++) {
    output[i] = 0;
  }for (var i = 0; i < input.length * 8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << i % 32;
  }return output;
}

function binl2rstr(input) {
  var output = "";
  for (var i = 0; i < input.length * 32; i += 8) {
    output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
  }return output;
}

function binl_md5(x, len) {
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;

  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);
}

function md5_cmn(q, a, b, x, s, t) {
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
}
function md5_ff(a, b, c, d, x, s, t) {
  return md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t) {
  return md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t) {
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t) {
  return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}

function safe_add(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xFFFF;
}

function bit_rol(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'process',
  props: {
    appear: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#process {\n  position: absolute;\n  z-index: 100;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n  text-align: center;\n}\n#process .process-content {\n  position: absolute;\n  display: block;\n  width: 100px;\n  height: 100px;\n  top: 50%;\n  left: 50%;\n  padding: 25px 0px;\n  margin-top: -50px;\n  margin-left: -50px;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n#process .process-content img {\n  width: 20px;\n  height: 20px;\n}\n", ""]);

// exports


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.appear),
      expression: "appear"
    }],
    staticClass: "process",
    attrs: {
      "id": "process"
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "process-content"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/loading.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("loading")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0ae76107", module.exports)
  }
}

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(34);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0103414f", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0ae76107\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0ae76107\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

var docEl = document.documentElement;
var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
var remSize = 100;
var recalc = function recalc() {
  var clientWidth = docEl.clientWidth;
  if (!clientWidth) {
    return;
  }
  if (clientWidth <= 720) {
    docEl.style.fontSize = remSize * (clientWidth / 500) + 'px';
  } else {
    docEl.style.fontSize = remSize + 'px';
  }
};

if (document.addEventListener) {
  window.addEventListener(resizeEvt, recalc, false);
  document.addEventListener('DOMContentLoaded', recalc, false);
}

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'basicheader',
  props: ['login'],
  methods: {
    exit: function exit() {
      console.log('logout');
      __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].setLocalStore('request_flag', 0);
      this.$http.get(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].passportHost + '/account/logout/').then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID, '');
        __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.TOKEN, '');
        __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.USER_NAME, '');
        window.location.href = 'index.html?action=logout';
      });
    },
    closeAcountAction: function closeAcountAction() {
      this.$router.push('/closeAcount');
    }
  }
});

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.body-header {\n  z-index: 10;\n  background-image: linear-gradient(#fafafa, #fafafa), linear-gradient(#fff, #fff);\n  background-blend-mode: normal, normal;\n}\n.body-header .header-wrapper-content {\n  display: -ms-flexbox;\n  display: flex;\n  width: 6.11rem;\n  position: absolute;\n  bottom: 0.14rem;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.body-header .header-operations {\n  height: 100%;\n  line-height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: auto;\n}\n.body-header .header-operations .info {\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n  color: #3d3d3d;\n  font-size: 0.12rem;\n  height: 0.2rem;\n  line-height: 0.2rem;\n}\n.body-header .header-operations .info span {\n  vertical-align: middle !important;\n}\n.body-header .header-operations .btn-img {\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n  color: #3d3d3d;\n  font-size: 0.12rem;\n  cursor: pointer;\n  height: 0.2rem;\n  line-height: 0.2rem;\n}\n.body-header .header-operations .btn-img span {\n  vertical-align: middle !important;\n}\n.body-header .header-operations .btn-img .iconfont {\n  color: #a7a7a7;\n}\n.body-header .header-operations .btn-img .icon-zhuxiao {\n  font-size: 0.2rem;\n}\n.body-header .header-operations .btn-img.close {\n  margin-right: 0.29rem;\n}\n.header-wrapper {\n  width: 1.75rem;\n}\nimg {\n  width: 1.04rem;\n}\n", ""]);

// exports


/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title"
    }],
    staticClass: "body-container",
    attrs: {
      "id": "login",
      "data-title": _vm.$t('titleText.account_CZUR')
    }
  }, [_c('basicheader', {
    attrs: {
      "login": false
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "lang": _vm.lang
    }
  }), _vm._v(" "), _c('czurfooter', {
    on: {
      "changeAppLocale": _vm.changeAppLocale
    }
  }), _vm._v(" "), (_vm.lang === 'en' && _vm.showCookie) ? _c('div', [(_vm.isPhone && _vm.lang) ? _c('mobileCookie') : _c('cookie')], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b45d8a6e", module.exports)
  }
}

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(46),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/components/header/header.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] header.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37f60726", Component.options)
  } else {
    hotAPI.reload("data-v-37f60726", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-header"
  }, [_c('div', {
    staticClass: "header-wrapper-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.login) ? _c('div', {
    staticClass: "header-operations"
  }, [_c('div', {
    staticClass: "btn-img close",
    on: {
      "click": _vm.closeAcountAction
    }
  }, [_c('span', {
    staticClass: "iconfont icon-zhuxiao"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('basic.close')))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-img logout",
    on: {
      "click": _vm.exit
    }
  }, [_c('span', {
    staticClass: "iconfont icon-tuichu"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('basic.logout')))])])]) : _c('div', {
    staticClass: "header-operations"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('index.info')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/header-logo.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37f60726", module.exports)
  }
}

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(43);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("31b93c16", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37f60726\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./header.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37f60726\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(372);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("22fc0f36", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b45d8a6e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b45d8a6e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(108)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  "data-v-83d2f514",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/components/country/countryCom.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] countryCom.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-83d2f514", Component.options)
  } else {
    hotAPI.reload("data-v-83d2f514", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(103)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/cookie/cookie.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] cookie.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2821ade3", Component.options)
  } else {
    hotAPI.reload("data-v-2821ade3", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(104)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(98),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/mobileCookie/mobileCookie.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] mobileCookie.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-297d6ae3", Component.options)
  } else {
    hotAPI.reload("data-v-297d6ae3", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(168)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/components/country/country.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] country.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-68664c8a", Component.options)
  } else {
    hotAPI.reload("data-v-68664c8a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  test: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  test_na: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  prod: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  },
  prod_na: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  }
};

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(166)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/components/login/login.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] login.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-550244e1", Component.options)
  } else {
    hotAPI.reload("data-v-550244e1", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_script_config_js__ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'countryCom',
  props: ['lang'],
  data: function data() {
    return {
      countryList: [],
      countryInfo: {},
      countryName: '',
      showList: false,
      language: ''
    };
  },
  created: function created() {
    var lang = __WEBPACK_IMPORTED_MODULE_1_common_script_config_js__["a" /* default */].cookieGet('lang');
    if (lang === 'en') {
      lang = 'en-US';
    }
    this.getCountryList(lang);
  },
  mounted: function mounted() {
    var _this = this;

    document.addEventListener('click', function (e) {
      if (_this.showList) {
        if (!_this.$refs.countryListWrap.contains(e.target)) {
          _this.showList = false;
        }
      }
    });
  },

  watch: {
    lang: function lang(value) {
      if (value === 'zh-CN') {
        this.countryName = this.countryInfo.countryName;
      } else if (value === 'zh-TW') {
        this.countryName = this.countryInfo.countryNameTw;
      } else {
        this.countryName = this.countryInfo.countryNameUs;
      }
    }
  },
  methods: {
    getCountryList: function getCountryList(lang) {
      var _this2 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1_common_script_config_js__["a" /* default */].passportHost + '/public/country/code?type=' + lang).then(function (response) {
        if (response.body.code === __WEBPACK_IMPORTED_MODULE_1_common_script_config_js__["a" /* default */].R_CODE.SUCCESS) {
          _this2.countryList = response.body.body.countryList;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this2.countryList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (item.defaultCountry) {
                _this2.countryInfo = item;
                _this2.$emit('input', _this2.countryInfo);
                if (_this2.lang === 'zh-CN') {
                  _this2.countryName = _this2.countryInfo.countryName;
                } else if (_this2.lang === 'zh-TW') {
                  _this2.countryName = _this2.countryInfo.countryNameTw;
                } else {
                  _this2.countryName = _this2.countryInfo.countryNameUs;
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      });
    },
    selectCountry: function selectCountry() {
      this.showList = !this.showList;
    },
    selectCountryAction: function selectCountryAction(country) {
      this.countryInfo = country;
      this.showList = false;
      this.$emit('input', this.countryInfo);
      if (this.lang === 'zh-CN') {
        this.countryName = this.countryInfo.countryName;
      } else if (this.lang === 'zh-TW') {
        this.countryName = this.countryInfo.countryNameTw;
      } else {
        this.countryName = this.countryInfo.countryNameUs;
      }
    }
  }
});

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loginCheck',
  created: function created() {
    var url = window.location.href;
    if (url.indexOf('u_id') > 0 && url.indexOf('token') > 0) {
      __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID, __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].getReqParam('u_id'));
      __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.TOKEN, __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].getReqParam('token'));
      url = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].urlRemoveParam(['u_id', 'token']);
      window.location.href = url;
    }
    this.loginCheck();
  },
  methods: {
    loginCheck: function loginCheck() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].getReqParam('action') === 'showInfo') {
        this.thirdAppLoginCheck();
      } else {
        this.$http.post(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].passportHost + '/login/check', {
          'u_id': __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID) === undefined ? 0 : __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID),
          'token': __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.TOKEN) === undefined ? '' : __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieGet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.TOKEN)
        }).then(function (response) {
          response = response.body;
          console.log(response);
          if (response.code === __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].R_CODE.INVALID_TOKEN) {
            _this.$emit('nologin');
          } else if (response.code === __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].R_CODE.SUCCESS) {
            _this.$emit('islogin');
          }
        });
      }
    },
    thirdAppLoginCheck: function thirdAppLoginCheck() {
      if (__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].getReqParam('action') === 'showInfo' && !__WEBPACK_IMPORTED_MODULE_1_common_script_validate_js__["a" /* default */].stringEmpty(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].getReqParam('token'))) {
        this.$http.post(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].passportHost + '/public/web/thirdApp/login', {
          'token': __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].getReqParam('token')
        }).then(function (response) {
          response = response.body;
          if (response.code === __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].R_CODE.SUCCESS) {
            __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.U_ID, response.body.id);
            __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.TOKEN, response.body.token);
            __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].cookieSet(__WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].COOKIE_KEY.USER_NAME, response.body.name);
            window.location.href = __WEBPACK_IMPORTED_MODULE_0_common_script_config_js__["a" /* default */].DEFAULT_PAGE;
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cookie',
  data: function data() {
    return {
      isShow: false,
      cookie_diaVisited: false,
      footer_diaVisited: false,
      cookie_necessary: 1,
      cookie_preference: 0,
      cookie_statistics: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isShow = true;
    }, 100);
  },
  created: function created() {
    console.log(localStorage.getItem('cookie_necessary'), '=====');
    if (localStorage.getItem('cookie_necessary') === '1') {
      this.footer_diaVisited = false;
    } else {
      this.footer_diaVisited = true;
    }
  },

  methods: {
    clickPrivact: function clickPrivact() {
      window.open('https://privacy.czur.cc/privacy_en');
    },
    accept_all: function accept_all() {
      this.cookie_necessary = 1;
      this.cookie_preference = 1;
      this.cookie_statistics = 1;
      this.Required_Only();
    },

    Required_Only: function Required_Only() {
      localStorage.setItem('cookie_necessary', this.cookie_necessary);
      localStorage.setItem('cookie_preference', this.cookie_preference);
      localStorage.setItem('cookie_statistics', this.cookie_statistics);
      this.footer_diaVisited = false;
      this.cookie_diaVisited = false;
    },
    openDia: function openDia() {
      this.cookie_diaVisited = true;
    },
    closeDio: function closeDio() {
      this.cookie_diaVisited = false;
    },
    preferClick: function preferClick() {
      this.cookie_diaVisited = true;
    }
  }
});

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cookie',
  data: function data() {
    return {
      isShow: false,
      cookie_diaVisited: false,
      footer_diaVisited: true,
      cookie_necessary: 1,
      cookie_preference: 0,
      cookie_statistics: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isShow = true;
    }, 100);
  },
  created: function created() {
    if (localStorage.getItem('cookie_necessary') === '1') {
      this.footer_diaVisited = false;
    }
  },

  methods: {
    clickPrivact: function clickPrivact() {
      window.open('https://privacy.czur.cc/privacy_en');
    },

    preferClick: function preferClick() {
      this.cookie_diaVisited = true;
    },
    closePreferDia: function closePreferDia() {
      this.cookie_diaVisited = false;
    },
    accept_all: function accept_all() {
      this.cookie_necessary = 1;
      this.cookie_preference = 1;
      this.cookie_statistics = 1;
      this.Required_Only();
    },

    Required_Only: function Required_Only() {
      localStorage.setItem('cookie_necessary', this.cookie_necessary);
      localStorage.setItem('cookie_preference', this.cookie_preference);
      localStorage.setItem('cookie_statistics', this.cookie_statistics);
      this.footer_diaVisited = false;
      this.cookie_diaVisited = false;
    }
  }
});

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  stringEmpty: function stringEmpty(value) {
    var empty = false;
    if (value === null || value === undefined || value === '' || value === 'null') {
      empty = true;
    }
    return empty;
  },
  validateEmail: function validateEmail(value) {
    var myreg = new RegExp(/[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/);
    if (!myreg.test(value)) {
      return false;
    } else {
      return true;
    }
  },
  isTel: function isTel(value) {
    var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
    var isMob = /^((\+?86)|(\(\+86\)))?1[3-9](\d{9})$/;
    if (isMob.test(value) || isPhone.test(value)) {
      return true;
    } else {
      return false;
    }
  },
  passwordRuleLow: function passwordRuleLow(password) {
    var validate = true;
    if (this.stringEmpty(password)) {
      validate = false;
    } else {
      if (password.length < 6 || password.length > 20) {
        validate = false;
      }
    }
    return validate;
  },
  passwordRule: function passwordRule(password) {
    var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/;
    return reg.test(password);
  },
  nameLenght: function nameLenght(str) {
    var arr = str.split('');
    var len = arr.length;
    var count = 0;
    for (var i = 0; i < len; i++) {
      var s = escape(arr[i]);
      if (s.indexOf('%u') > -1) {
        count = count + 2;
      } else {
        count++;
      }
    }
    return count <= 14;
  },
  isEmojiCharacter: function isEmojiCharacter(substring) {
    for (var i = 0; i < substring.length; i++) {
      var hs = substring.charCodeAt(i);
      if (hs >= 0xd800 && hs <= 0xdbff) {
        if (substring.length > 1) {
          var ls = substring.charCodeAt(i + 1);
          var uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000;
          if (uc >= 0x10119 && uc <= 0x1f9c0) {
            return true;
          }
        }
      } else if (substring.length > 1) {
        var lsi = substring.charCodeAt(i + 1);
        if (lsi == 0x20e3) {
          return true;
        } else if (lsi == 0xd83c) {
          return true;
        } else if (lsi == 0xfe0f) {
          return true;
        } else if (lsi == 0xfe0e) {
          return true;
        }
      } else {
        if (hs >= 0x2100 && hs <= 0x27ff) {
          return true;
        } else if (hs >= 0x2B05 && hs <= 0x2b07) {
          return true;
        } else if (hs >= 0x2934 && hs <= 0x2935) {
          return true;
        } else if (hs >= 0x3297 && hs <= 0x3299) {
          return true;
        } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030 || hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b || hs == 0x2b50) {
          return true;
        }
      }
      if (hs == 0x20) {
        return true;
      }
    }
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#cookie {\n  margin: 0.25rem;\n  font-size: 0.18rem;\n  text-align: justify;\n  text-indent: 0 !important;\n}\n#cookie div {\n  text-indent: 0 !important;\n}\n#cookie .footer_con {\n  position: fixed;\n  bottom: -1%;\n  box-shadow: 4px 4px 15px #b6b6b6;\n  width: 99%;\n  left: -0.005rem;\n  padding: 1%;\n  background-color: #fff;\n  padding-left: 12%;\n}\n#cookie .clicksty {\n  color: #00f;\n  cursor: pointer;\n}\n#cookie .detail_con {\n  position: fixed;\n  background-color: #fff;\n  width: 50%;\n  top: 10%;\n  left: 24%;\n  box-shadow: 4px 4px 15px #b6b6b6;\n  padding: 25px;\n  color: #3d3d3d;\n  border-radius: 0.1rem;\n  height: 57%;\n  overflow: auto;\n}\n#cookie .cookie_title {\n  color: #3d3d3d;\n  font-weight: bold;\n  font-size: 0.23rem;\n  border-bottom: 1px solid #d8d8d8;\n  padding-bottom: 0.1rem;\n}\n#cookie .cookie_title .closeBtn {\n  float: right;\n  cursor: pointer;\n}\n#cookie .cookie_three {\n  padding-top: 0.1rem;\n}\n#cookie .el-icon-circle-check {\n  color: #008000;\n  font-size: 0.25rem;\n  font-weight: bold;\n  width: 0.3rem;\n  vertical-align: bottom;\n}\n#cookie .el-icon-remove-outline {\n  font-size: 0.25rem;\n  font-weight: bold;\n  width: 0.3rem;\n  vertical-align: bottom;\n}\n#cookie .content {\n  padding-left: 0.3rem;\n}\n#cookie .content:last-child {\n  border-bottom: 1px solid #d8d8d8;\n  padding-bottom: 0.2rem;\n}\n#cookie .headerTitle {\n  padding: 0.1rem 0;\n}\n#cookie .headerTest {\n  font-weight: bold;\n  font-size: 0.21rem;\n}\n#cookie .headerTest .morenBtn {\n  position: absolute;\n  right: 13%;\n  cursor: pointer;\n}\n#cookie .footer_text {\n  width: 60%;\n  display: inline-block;\n}\n#cookie .btn1 {\n  border: 1px solid #000;\n  padding: 6px;\n  border-radius: 8px;\n  margin-right: 25px;\n  cursor: pointer;\n}\n#cookie .btn2 {\n  background-color: #000;\n  color: #fff;\n  padding: 6px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n#cookie .dia_but {\n  display: inline-block;\n  font-size: 0.18rem;\n  vertical-align: top;\n  margin-top: 0.12rem;\n  margin-left: 0.3rem;\n  padding-top: 0.2rem;\n  float: right;\n}\n#cookie .footer_but {\n  display: inline-block;\n  font-size: 0.18rem;\n  vertical-align: top;\n  margin-top: 0.12rem;\n  margin-left: 0.3rem;\n}\n", ""]);

// exports


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#mobileCookie {\n  font-size: 0.18rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  text-indent: 0 !important;\n  height: auto;\n}\n#mobileCookie div {\n  text-indent: 0 !important;\n}\n#mobileCookie .footer_con {\n  position: fixed;\n  bottom: -1%;\n  box-shadow: 4px 4px 15px #b6b6b6;\n  width: 99%;\n  left: 0;\n  padding: 0.5%;\n  background-color: #fff;\n  padding-left: 8%;\n  height: 37%;\n}\n#mobileCookie .clicksty {\n  color: #00f;\n}\n#mobileCookie .detail_con {\n  position: fixed;\n  background-color: #fff;\n  width: 87%;\n  top: 7%;\n  left: 0%;\n  box-shadow: 4px 4px 15px #b6b6b6;\n  padding: 25px;\n  color: #3d3d3d;\n  border-radius: 0.1rem;\n  display: block;\n  overflow: auto;\n  height: 65%;\n  z-index: 1;\n}\n#mobileCookie .cookie_title {\n  color: #3d3d3d;\n  font-weight: bold;\n  font-size: 0.23rem;\n  border-bottom: 1px solid #d8d8d8;\n  padding-bottom: 0.1rem;\n}\n#mobileCookie .cookie_title .closeBtn {\n  float: right;\n}\n#mobileCookie .cookie_three {\n  padding-top: 0.2rem;\n}\n#mobileCookie .el-icon-circle-check {\n  color: #008000;\n  font-size: 0.25rem;\n  font-weight: bold;\n  width: 0.3rem;\n  vertical-align: bottom;\n}\n#mobileCookie .el-icon-remove-outline {\n  font-size: 0.25rem;\n  font-weight: bold;\n  width: 0.3rem;\n  vertical-align: bottom;\n}\n#mobileCookie .content {\n  padding-left: 0.3rem;\n}\n#mobileCookie .content:last-child {\n  border-bottom: 1px solid #d8d8d8;\n  padding-bottom: 0.2rem;\n}\n#mobileCookie .headerTitle {\n  padding: 0.1rem 0;\n}\n#mobileCookie .headerTest {\n  font-weight: bold;\n  font-size: 0.21rem;\n  padding: 0.1rem 0;\n}\n#mobileCookie .headerTest .closeBtn {\n  position: absolute;\n  right: 15%;\n}\n#mobileCookie .footer_text {\n  width: 85%;\n  display: inline-block;\n}\n#mobileCookie .btn1 {\n  border: 1px solid #000;\n  padding: 6px;\n  border-radius: 8px;\n  margin-right: 25px;\n}\n#mobileCookie .btn2 {\n  background-color: #000;\n  color: #fff;\n  padding: 6px;\n  border-radius: 8px;\n}\n#mobileCookie .dia_but {\n  display: inline-block;\n  font-size: 0.18rem;\n  vertical-align: top;\n  margin-top: 0.12rem;\n  margin-left: 0.3rem;\n  padding-top: 0.2rem;\n  float: right;\n}\n#mobileCookie .footer_but {\n  display: inline-block;\n  font-size: 0.18rem;\n  vertical-align: top;\n  margin-top: 0.3rem;\n  margin-left: -0.3rem;\n  width: 100%;\n  text-align: center;\n}\n", ""]);

// exports


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n.country-com-wrap[data-v-83d2f514] {\n  width: 3.05rem;\n  height: 0.44rem;\n  background-color: #f6f6f6;\n  position: relative;\n  border-radius: 0.04rem;\n  position: relative;\n}\n.country-com-wrap .icon[data-v-83d2f514] {\n  position: absolute;\n  right: 0.12rem;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 0.1rem;\n  color: #979797;\n}\n.country-com-wrap .country-value[data-v-83d2f514] {\n  max-width: 100%;\n  height: 0.44rem;\n  line-height: 0.44rem;\n  font-size: 0.12rem;\n  color: #adadad;\n  text-align: center;\n}\n.country-com-wrap .country-list-scroll[data-v-83d2f514] {\n  position: absolute;\n  width: 3.05rem;\n  height: 2.25rem;\n  overflow-y: scroll;\n  background-color: #f6f6f6;\n  padding: 0.05rem 0;\n  border-bottom-left-radius: 0.04rem;\n  border-bottom-right-radius: 0.04rem;\n}\n.country-com-wrap .country-list-scroll .country-list[data-v-83d2f514] {\n  width: 100%;\n}\n.country-com-wrap .country-list-scroll .country-list .country[data-v-83d2f514] {\n  width: 100%;\n  height: 0.36rem;\n  background-color: #f6f6f6;\n  border-radius: 0.04rem;\n  position: relative;\n}\n.country-com-wrap .country-list-scroll .country-list .country[data-v-83d2f514]:hover {\n  background-color: #ededed;\n}\n.country-com-wrap .country-list-scroll .country-list .country .country-text[data-v-83d2f514] {\n  max-width: 100%;\n  height: 0.44rem;\n  line-height: 0.44rem;\n  font-size: 0.12rem;\n  color: #adadad;\n  text-align: center;\n}\n.country-com-wrap .country-list-scroll .country-list .country .icon-selected[data-v-83d2f514] {\n  position: absolute;\n  right: 0.12rem;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 0.1rem;\n  color: #979797;\n}\n", ""]);

// exports


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cookie-body-container",
    attrs: {
      "id": "cookie"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "cookie-body-content"
  }, [(_vm.cookie_diaVisited) ? _c('div', {
    staticClass: "detail_con"
  }, [_c('div', {
    staticClass: "cookie_title"
  }, [_vm._v("\n        Cookie Preferences\n        "), _c('span', {
    staticClass: "closeBtn",
    on: {
      "click": _vm.closeDio
    }
  }, [_vm._v("X")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dia_but"
  }, [_c('span', {
    staticClass: "btn1",
    on: {
      "click": _vm.Required_Only
    }
  }, [_vm._v("Required Only")]), _vm._v(" "), _c('span', {
    staticClass: "btn2",
    on: {
      "click": _vm.accept_all
    }
  }, [_vm._v("Accept All")])])]) : _vm._e(), _vm._v(" "), (_vm.footer_diaVisited) ? _c('div', {
    staticClass: "footer_con"
  }, [_c('div', {
    staticClass: "headerTest"
  }, [_vm._v("\n        We Value Your Privacy\n        "), _c('span', {
    staticClass: "morenBtn",
    on: {
      "click": _vm.Required_Only
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "footer_text"
  }, [_vm._v("\n        We use  cookies to maintain the essential functionality of our website and\n        detect website performance to help us improve our website and online products and services, as well as improving your experience by providing personalized content.\n        You can manage your settings at any time through "), _c('span', {
    staticClass: "clicksty",
    on: {
      "click": _vm.preferClick
    }
  }, [_vm._v("Cookie Preferences")]), _vm._v(" or read our "), _c('span', {
    staticClass: "clicksty",
    on: {
      "click": _vm.clickPrivact
    }
  }, [_vm._v("Cookie Policy")]), _vm._v(" to learn more.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "footer_but"
  }, [_c('span', {
    staticClass: "btn1",
    on: {
      "click": _vm.openDia
    }
  }, [_vm._v("Cookie Preferences")]), _vm._v(" "), _c('span', {
    staticClass: "btn2",
    on: {
      "click": _vm.accept_all
    }
  }, [_vm._v("Accept All")])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cookie_three"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("Cookies are small files which, when placed on your device, enable us to provide certain features and functionality of CZUR websites and online services to you. We use the following types of cookies on our websites. View Cookie Policy for full details."), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "headerTitle"
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  }), _c('span', {
    staticClass: "headerTest"
  }, [_vm._v("Strictly Necessary Cookies")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("These cookies are essential for you to use our websites, such as the cookies used for carrying out the transmission of a communication, the cookies that record requests for information from the Internet and block web attacks so as to ensure web security, the cookies that are strictly necessary for us to provide information society services that you request. You must accept strictly necessary cookies to be able to use our websites.")]), _vm._v(" "), _c('div', {
    staticClass: "headerTitle"
  }, [_c('i', {
    staticClass: "el-icon-remove-outline"
  }), _c('span', {
    staticClass: "headerTest"
  }, [_vm._v("Preference Cookies")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("These cookies are also known as \"functionality cookies\", these cookies allow us to remember choices you have made through your use of our websites, what region you are in, or what your username and password are so you can automatically log in. These cookies can help us reallocate work load among our servers and enable our webpages to respond faster.")]), _vm._v(" "), _c('div', {
    staticClass: "headerTitle"
  }, [_c('i', {
    staticClass: "el-icon-remove-outline"
  }), _c('span', {
    staticClass: "headerTest"
  }, [_vm._v("Statistics Cookies")])]), _vm._v(" "), _c('div', {
    staticClass: "content lastContent"
  }, [_vm._v("These cookies are also known as \"performance cookies\", these cookies collect information about how you use our websites, like which web pages you visited and which links you clicked on. These cookies can help us to improve your browsing experience on our websites.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2821ade3", module.exports)
  }
}

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "mobileCookie"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "body-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cookie_diaVisited),
      expression: "cookie_diaVisited"
    }],
    staticClass: "detail_con"
  }, [_c('div', {
    staticClass: "cookie_title"
  }, [_vm._v("\n        Cookie Preferences\n        "), _c('span', {
    staticClass: "closeBtn",
    on: {
      "click": _vm.closePreferDia
    }
  }, [_vm._v("X")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dia_but"
  }, [_c('span', {
    staticClass: "btn1",
    on: {
      "click": _vm.Required_Only
    }
  }, [_vm._v("Required Only")]), _vm._v(" "), _c('span', {
    staticClass: "btn2",
    on: {
      "click": _vm.accept_all
    }
  }, [_vm._v("Accept All")])])]), _vm._v(" "), (_vm.footer_diaVisited) ? _c('div', {
    staticClass: "footer_con"
  }, [_c('div', {
    staticClass: "headerTest"
  }, [_vm._v("\n        We Value Your Privacy\n        "), _c('span', {
    staticClass: "closeBtn",
    on: {
      "click": _vm.Required_Only
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "footer_text"
  }, [_vm._v("\n        We use  cookies to maintain the essential functionality of our website and\n        detect website performance to help us improve our website and online products and services, as well as improving your experience by providing personalized content.\n        You can manage your settings at any time through "), _c('span', {
    staticClass: "clicksty",
    on: {
      "click": _vm.preferClick
    }
  }, [_vm._v("Cookie Preferences")]), _vm._v(" or read our "), _c('span', {
    staticClass: "clicksty",
    on: {
      "click": _vm.clickPrivact
    }
  }, [_vm._v("Cookie Policy")]), _vm._v(" to learn more.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "footer_but"
  }, [_c('span', {
    staticClass: "btn1",
    on: {
      "click": _vm.preferClick
    }
  }, [_vm._v("Cookie Preferences")]), _vm._v(" "), _c('span', {
    staticClass: "btn2",
    on: {
      "click": _vm.accept_all
    }
  }, [_vm._v("Accept All")])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cookie_three"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("Cookies are small files which, when placed on your device, enable us to provide certain features and functionality of CZUR websites and online services to you. We use the following types of cookies on our websites. View Cookie Policy for full details."), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "headerTitle"
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  }), _c('span', {
    staticClass: "headerTest"
  }, [_vm._v("Strictly Necessary Cookies")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("These cookies are essential for you to use our websites, such as the cookies used for carrying out the transmission of a communication, the cookies that record requests for information from the Internet and block web attacks so as to ensure web security, the cookies that are strictly necessary for us to provide information society services that you request. You must accept strictly necessary cookies to be able to use our websites.")]), _vm._v(" "), _c('div', {
    staticClass: "headerTitle"
  }, [_c('i', {
    staticClass: "el-icon-remove-outline"
  }), _c('span', {
    staticClass: "headerTest"
  }, [_vm._v("Preference Cookies")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("These cookies are also known as \"functionality cookies\", these cookies allow us to remember choices you have made through your use of our websites, what region you are in, or what your username and password are so you can automatically log in. These cookies can help us reallocate work load among our servers and enable our webpages to respond faster.")]), _vm._v(" "), _c('div', {
    staticClass: "headerTitle"
  }, [_c('i', {
    staticClass: "el-icon-remove-outline"
  }), _c('span', {
    staticClass: "headerTest"
  }, [_vm._v("Statistics Cookies")])]), _vm._v(" "), _c('div', {
    staticClass: "content lastContent"
  }, [_vm._v("These cookies are also known as \"performance cookies\", these cookies collect information about how you use our websites, like which web pages you visited and which links you clicked on. These cookies can help us to improve your browsing experience on our websites.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-297d6ae3", module.exports)
  }
}

/***/ })

},[259]);


// WEBPACK FOOTER //
// static/js/module/index.f0f3a2e9a21a68230f81.js